export default {
    "de": {
        "{Attribute} {lang}": "{Attribute} {lang}",
        "{Attribute} is invalid": "{Attribute} ist ungültig",
        "{count} characters": "{count} Zeichen",
        "{model} {action}": "{model} {action}",
        "(and {count} more error)": "(und {count} weiterer Fehler)",
        "(and {count} more errors)": "(und {count} weiterer Fehler)|(und {count} weitere Fehler)|(und {count} weitere Fehler)",
        "*Required fields": "*Pflichtfelder",
        "1 star": "1 Stern",
        "2 stars": "2 Sterne",
        "3 stars": "3 Sterne",
        "4 stars": "4 Sterne",
        "404 - Page not found": "404 - Seite nicht gefunden",
        "5 stars": "5 Sterne",
        "8-12 hours": "8-12 Stunden",
        "A decryption key is required.": "Ein Entschlüsselungsschlüssel ist nötig.",
        "A piece": "Ein Stück",
        "A Timeout Occurred": "Eine Zeitüberschreitung ist aufgetreten",
        "About HGBI": "Über HGBI",
        "About the cookies on this website": "Über die Cookies auf dieser Website",
        "About us": "Über uns",
        "Accept": "Akzeptieren",
        "Accepted": "Akzeptiert",
        "Account": "Konto",
        "Action": "Aktion",
        "Actions": "Aktionen",
        "activated": "aktiviert",
        "Activated": "Aktiviert",
        "Active": "Aktiv",
        "Add": "Hinzufügen",
        "Add {name}": "{name} hinzufügen",
        "Add a underline to all titles": "Allen Titeln eine Unterstreichung hinzufügen",
        "Add menu item": "Menüpunkt hinzufügen",
        "Add message": "Nachricht hinzufügen",
        "Add page block": "Seitenblock hinzufügen",
        "Add phone number in global template options": "Telefonnummer in den globalen Vorlagenoptionen hinzufügen",
        "Admin": "Administrator",
        "Agree": "Zustimmen",
        "All": "Alle",
        "All {models}": "Alle {models}",
        "All block content in the language you are editing is replaced by the content of the language you pick. This cannot be undone.": "Alle Blockinhalte in der Sprache, die du bearbeitest, werden durch die Inhalte der gewählten Sprache ersetzt. Dies kann nicht rückgängig gemacht werden.",
        "All news (Including filter and pagination)": "Alle News (inklusive Filter und Seiten-Navigation)",
        "All projects (Including filter and pagination)": "Alle Projekte (inklusive Filter und Seiten-Navigation)",
        "All rights reserved.": "Alle Rechte vorbehalten.",
        "All team members (Including pagination)": "Alle Teammitglieder (inklusive Seiten-Navigation)",
        "All vacancies (Including filter and pagination)": "Alle Stellenangebote (inklusive Filter und Seiten-Navigation)",
        "Already Reported": "Bereits gemeldet",
        "Alt text": "Alt-Text",
        "Amount Blogs": "Anzahl Blogs",
        "Amount news": "Anzahl News",
        "Amount projects": "Anzahl Projekte",
        "Amount team members": "Anzahl Teammitglieder",
        "Amount vacancies": "Anzahl Stellenangebote",
        "Answer": "Antwort",
        "any": "beliebig",
        "Apply directly": "Direkt bewerben",
        "Apply discount code": "Rabattcode anwenden",
        "Apply now": "Jetzt bewerben",
        "Archive": "Archiv",
        "Assign": "Zuordnen",
        "Associate": "Assoziieren",
        "Attach": "Anhängen",
        "Author": "Autor",
        "Author:": "Autor:",
        "Back": "Zurück",
        "Back and mark as done": "Zurück und als erledigt markieren",
        "Back and release": "Zurück und freigeben",
        "Back to home": "Zurück zur Startseite",
        "Background color": "Hintergrundfarbe",
        "Background image": "Hintergrundbild",
        "Backup codes": "Sicherungscodes",
        "Bad Gateway": "Fehlerhaftes Gateway",
        "Bad Request": "Ungültige Anfrage",
        "Bandwidth Limit Exceeded": "Bandbreitenlimit überschritten",
        "Banner": "Banner",
        "Banner (Slider Variant)": "Banner (Slider-Variante)",
        "Birthday *": "Geburtstag *",
        "Black": "Schwarz",
        "Blog": "Blog",
        "Blog Content": "Blog-Inhalt",
        "Blog Settings": "Blog-Einstellungen",
        "Blogs": "Blogs",
        "Blogs (Including filter and pagination)": "Blogs (inklusive Filter und Paginierung)",
        "Body color": "Body-Farbe",
        "Bold": "Fett",
        "Browse": "Durchsuchen",
        "Bullet point": "Aufzählungspunkt",
        "Bullet points": "Aufzählungspunkte",
        "Button corners": "Button-Ecken",
        "Button label": "Button-Beschriftung",
        "Button only shows up if module is set to active": "Der Button wird nur angezeigt, wenn das Modul auf aktiv gesetzt ist",
        "Buttons": "Buttons",
        "Cancel": "Abbrechen",
        "Checkout page": "Checkout-Seite",
        "Choose": "Wählen Sie",
        "Choose {name}": "Wählen Sie {name}",
        "Choose file": "Datei wählen",
        "Choose File": "Datei wählen",
        "Choose Image": "Bild wählen",
        "City": "Stadt",
        "Click to copy": "Klicken Sie zum Kopieren",
        "Client": "Kunde",
        "Client Closed Request": "Client hat die Anfrage geschlossen",
        "Clients": "Kunden",
        "Close": "Schließen",
        "Close conversation": "Konversation schließen",
        "closed": "geschlossen",
        "code": "Code",
        "Collapse": "Zusammenklappen",
        "Collapse All": "Alle zusammenklappen",
        "Comment": "Kommentar",
        "Company name": "Firmenname",
        "Complete": "Abgeschlossen",
        "Concept in only visible to logged in users, draft is not visible to anyone": "Konzept ist nur für angemeldete Benutzer sichtbar, Entwurf ist für niemanden sichtbar",
        "Confirm": "Bestätigen",
        "Conflict": "Konflikt",
        "Connect": "Verbinden",
        "Connection Closed Without Response": "Verbindung ohne Antwort getrennt",
        "Connection Timed Out": "Verbindungszeit überschritten",
        "Consultant": "Berater",
        "Contact": "Kontakt",
        "Contact form": "Kontaktformular",
        "Contactform": "Kontaktformular",
        "Content": "Inhalt",
        "Content copied": "Inhalte kopiert",
        "Continue": "Weiter",
        "Conversation": "Konversation",
        "Conversations": "Konversationen",
        "Copy and overwrite": "Kopieren und überschreiben",
        "Copy content from another language": "Inhalte aus einer anderen Sprache kopieren",
        "Copy content to {locale}": "Inhalte nach {locale} kopieren",
        "Copy from": "Kopieren aus",
        "Copy from {locale}": "Aus {locale} kopieren",
        "Copy the image from {locale}": "Das Bild aus {locale} kopieren",
        "Copy this block from {locale}": "Diesen Block aus {locale} kopieren",
        "Counter": "Zähler",
        "Counter number": "Zählernummer",
        "Counter Short description": "Zähler-Kurzbeschreibung",
        "Counter title": "Zählertitel",
        "Counters": "Zähler",
        "create": "erstellen",
        "Create": "Erstellen",
        "Create {model}": "{model} erstellen",
        "Create {name}": "{name} erstellen",
        "Create a password": "Passwort erstellen",
        "Create follow-up": "Follow-up erstellen",
        "Create order": "Bestellung erstellen",
        "created": "erstellt",
        "Created": "Erstellt",
        "Created at": "Erstellt am ",
        "Created At": "Erstellt am",
        "Custom": "Benutzerdefiniert",
        "Custom background color": "Benutzerdefinierte Hintergrundfarbe",
        "Custom text color": "Benutzerdefinierte Textfarbe",
        "Custom title": "Benutzerdefinierter Titel",
        "Customers will be shown the cheapest applicable shipping rate from each group. Currently existing groups: {groups}": "Kunden wird der günstigste zutreffende Versandtarif aus jeder Gruppe angezeigt. Aktuell bestehende Gruppen: {groups}",
        "Dangerously high": "Gefährlich hoch",
        "Dangerously high explanation": "Erläuterung zu gefährlich hoch",
        "Dangerously Low": "Gefährlich niedrig",
        "Dangerously low explanation": "Erläuterung zu gefährlich niedrig",
        "Date": "Datum",
        "Date of birth": "Geburtsdatum",
        "Deactivate": "Deaktivieren",
        "deactivated": "deaktiviert",
        "Deactivated": "Deaktiviert",
        "Dear": "Liebe/r",
        "Default consultant": "Standardberater",
        "delete": "löschen",
        "Delete": "Löschen",
        "Delete {name}": "{name} löschen",
        "Delete filters": "Filter löschen",
        "deleted": "gelöscht",
        "description": "Beschreibung",
        "Description": "Beschreibung",
        "Desktop": "Desktop",
        "Detach": "Trennen",
        "Details": "Details",
        "Disable": "Deaktivieren",
        "Discard": "Verwerfen",
        "Discount": "Rabatt",
        "Discount active": "Rabatt aktiv",
        "Discount code": "Rabattcode",
        "done": "erledigt",
        "Done": "Erledigt",
        "Down": "Runter",
        "Download app": "App herunterladen",
        "Download backup codes and continue.": "Laden Sie die Backup-Codes herunter und fahren Sie fort.",
        "Download PDF button name": "Name der Schaltfläche „PDF herunterladen“",
        "Due at": "Fällig am",
        "Duplicate": "Duplizieren",
        "Duplicate {name}": "{name} duplizieren",
        "E-mail": "E-Mail",
        "E-mail *": "E-Mail *",
        "edit": "bearbeiten",
        "Edit": "Bearbeiten",
        "Edit {model}": "{model} bearbeiten",
        "Edit {name}": "{name} bearbeiten",
        "Edit account": "Konto bearbeiten",
        "email": "E-Mail",
        "Email": "E-Mail",
        "Employees": "Mitarbeiter",
        "employers": "Arbeitgeber",
        "Employers": "Arbeitgeber",
        "Enable": "Aktivieren",
        "Encrypted environment file already exists.": "Verschlüsselte Umgebungsdatei ist bereits vorhanden.",
        "Encrypted environment file not found.": "Verschlüsselte Umgebungsdatei nicht gefunden.",
        "End": "Ende",
        "Enter working hours here": "Geben Sie hier die Arbeitszeiten ein",
        "Environment file already exists.": "Umgebungsdatei ist bereits vorhanden.",
        "Environment file not found.": "Umgebungsdatei nicht gefunden.",
        "errors": "Fehler",
        "excerpt": "Auszug",
        "Excerpt": "Auszug",
        "Expand": "Erweitern",
        "Expand All": "Alle erweitern",
        "Expectation Failed": "Erwartung gescheitert",
        "Explanation": "Erläuterung",
        "Export": "Exportieren",
        "Export {name}": "{name} exportieren",
        "External Test": "Externer Test",
        "External Tester": "Externer Tester",
        "External URL": "Externe URL",
        "Facebook url": "Facebook-URL",
        "Failed Dependency": "Fehlgeschlagene Abhängigkeit",
        "Faq": "FAQ",
        "Faqoverview": "FAQ-Übersicht",
        "File": "Datei",
        "Files": "Dateien",
        "Fill in the 6-digit code": "Geben Sie den 6-stelligen Code ein",
        "First name": "Vorname",
        "First name *": "Vorname *",
        "Fixed Cta": "Fixierte Cta",
        "Follow up to": "Follow-up bis",
        "Follow up tot": "Follow-up bis",
        "Font": "Schriftart",
        "Font size": "Schriftgröße",
        "Font weight": "Schriftstärke",
        "Footer background color": "Footer-Hintergrundfarbe",
        "Footer bottom right": "Footer unten rechts",
        "Footer color": "Footer-Farbe",
        "Footer contact title": "Footer-Kontakttitel",
        "Footer opening hours title (the middle one)": "Footer-Öffnungszeiten-Titel (der mittlere)",
        "Footer socials text": "Footer-Social-Media-Text",
        "Footer socials title": "Footer-Social-Media-Titel",
        "Footer socials title (the last one)": "Footer-Social-Media-Titel (der letzte)",
        "Footer text color": "Footer-Textfarbe",
        "Forbidden": "Verboten",
        "Form Submission": "Formularübermittlung",
        "Found": "Gefunden",
        "Frequently asked questions": "Häufig gestellte Fragen",
        "From the authenticator app": "Aus der Authenticator-App",
        "Fully rounded": "Vollständig abgerundet",
        "Gallery": "Galerie",
        "Gateway Timeout": "Gateway-Zeitüberschreitung",
        "Global": "Global",
        "Go Home": "Zur Startseite",
        "Go to page {page}": "Gehe zur Seite {page}",
        "Gone": "Nicht mehr verfügbar",
        "Google Authenticator": "Google Authenticator",
        "Google Maps": "Google Maps",
        "Google Maps Iframe": "Google Maps Iframe",
        "Google maps URL": "Google maps URL",
        "Google Maps URL": "Google Maps URL",
        "Header Opening hours": "Header-Öffnungszeiten",
        "Heading": "Überschrift",
        "Heading 1 is the main title and will be used on every page once": "Überschrift 1 ist der Haupttitel und wird auf jeder Seite einmal verwendet",
        "Heading 2 are the subtitles and can be used multiple times on a page": "Überschrift 2 sind die Untertitel und können auf einer Seite mehrmals verwendet werden",
        "Heading color": "Überschriftsfarbe",
        "Hello": "Hallo",
        "Hello!": "Hallo!",
        "Here you can turn on extra modules that are not included in the standard basic MediaMix template. Those are paid modules.": "Hier können Sie zusätzliche Module aktivieren, die nicht im Standard-Basis-MediaMix-Template enthalten sind. Dies sind kostenpflichtige Module.",
        "Hide": "Verstecken",
        "Hide {name}": "{name} ausblenden",
        "High": "Hoch",
        "High explanation": "Erläuterung zu Hoch",
        "Highest": "Höchste",
        "Hits": "Treffer",
        "Home": "Startseite",
        "Home Banner Slider Variant": "Startseiten-Banner-Slider-Variante",
        "hour": "Stunde",
        "Hours": "Stunden",
        "HTTP Version Not Supported": "HTTP Version nicht unterstützt",
        "https://nl.linkedin.com/company/strixi": "https://nl.linkedin.com/company/strixi",
        "https://www.facebook.com/strixi.nl/": "https://www.facebook.com/strixi.nl/",
        "https://www.instagram.com/strixi.nl/": "https://www.instagram.com/strixi.nl/",
        "I agree with the": "Ich stimme den",
        "I agree with the terms and conditions*": "Ich stimme den Allgemeinen Geschäftsbedingungen zu*",
        "I have saved the backup codes": "Ich habe die Backup-Codes gespeichert",
        "I'm a teapot": "Ich bin eine Teekanne",
        "Icon": "Symbol",
        "If enabled, and no image is uploaded, the banner from the homepage will be shown.": "Wenn aktiviert und kein Bild hochgeladen wurde, wird der Banner von der Startseite angezeigt.",
        "If you did not create an account, no further action is required.": "Wenn Sie kein Konto erstellt haben, sind keine weiteren Handlungen nötig.",
        "If you did not request a password reset, no further action is required.": "Wenn Sie kein Zurücksetzen des Passworts beantragt haben, sind keine weiteren Handlungen nötig.",
        "If you're having trouble clicking the \"{actionText}\" button, copy and paste the URL belowninto your web browser:": "Sollten Sie Schwierigkeiten haben, die Schaltfläche \"{actionText}\" zu klicken, kopieren Sie den nachfolgenden Linkn in Ihre Adresszeile des Browsers.",
        "IM Used": "IM verwendet",
        "Image": "Bild",
        "Impersonate": "Imitieren",
        "Impersonation": "Identitätswechsel",
        "Import": "Importieren",
        "Import {name}": "Importieren Sie {name}",
        "Including VAT": "Inklusive MwSt.",
        "Index Page": "Übersichtsseite",
        "Ingredients": "Zutaten",
        "Inloggen": "Einloggen",
        "Inspection": "Inspektion",
        "Instagram url": "Instagram-URL",
        "Instruction title": "Anleitungstitel",
        "Insufficient Storage": "Nicht genügend Speicherplatz",
        "Internal comment": "Interner Kommentar",
        "Internal comments": "Interne Kommentare",
        "Internal Server Error": "Interner Serverfehler",
        "Introduction": "Einführung",
        "Invalid filename.": "Ungültiger Dateiname.",
        "Invalid JSON was returned from the route.": "Von der Route wurde ein ungültiger JSON-Code zurückgegeben.",
        "Invalid phone number": "Ungültige Telefonnummer",
        "Invalid SSL Certificate": "Ungültiges SSL-Zertifikat",
        "It is recommended to keep the {attribute} between {min} and {max} characters long": "Es wird empfohlen, dass {attribute} zwischen {min} und {max} Zeichen lang ist",
        "Job position": "Position",
        "Kind regards,": "Mit freundlichen Grüßen,",
        "Label Button": "Label-Schaltfläche",
        "Language": "Sprache",
        "Last message on": "Letzte Nachricht am",
        "Last name": "Nachname",
        "Last name *": "Nachname *",
        "Last refresh was {quantity} {unit} ago": "Letzte Aktualisierung war vor {quantity} {unit}",
        "Leave empty for no end date": "Leer lassen für kein Enddatum",
        "Leave empty to use parent details": "Leer lassen, um die übergeordneten Details zu verwenden",
        "length": "Länge",
        "Length Required": "Längenangabe erforderlich",
        "Light": "Hell",
        "Like": "Wie",
        "Line height": "Zeilenhöhe",
        "Link Button": "Link-Schaltfläche",
        "LinkedIn url": "LinkedIn-URL",
        "Load": "Belastung",
        "Locale": "Sprache",
        "Localize": "Lokalisieren",
        "Location": "Standort",
        "Locked": "Gesperrt",
        "Log In": "Einloggen",
        "Log Out": "Abmelden",
        "Login": "Anmelden",
        "Logo height": "Logo-Höhe",
        "Logo slider": "Logo-Slider",
        "Logoslider": "Logoslider",
        "Logout": "Abmelden",
        "Loop Detected": "Endlosschleife erkannt",
        "Low": "Niedrig",
        "Low explanation": "Niedrige Erläuterung",
        "Lowest": "Niedrigste",
        "Made by:": "Erstellt von:",
        "Maintenance Mode": "Wartungsmodus",
        "Mark as done": "Als erledigt markieren",
        "Medical": "Medizinisch",
        "Medium": "Mittel",
        "Menu Card": "Speisekarte",
        "Menu Card Item": "Speisekarten-Artikel",
        "Menu items": "Menüpunkte",
        "Menu Title": "Menütitel",
        "Menucard": "Speisekarte",
        "Message": "Nachricht",
        "Message *": "Nachricht *",
        "Messages": "Nachrichten",
        "Method Not Allowed": "Methode nicht erlaubt",
        "Metric Name": "Metrikname",
        "Microsoft Authenticator": "Microsoft Authenticator",
        "minus icon": "minus-Symbol",
        "minute": "Minute",
        "minutes": "Minuten",
        "Misdirected Request": "Fehlgeleitete Anfrage",
        "Mobile": "Mobil",
        "Modules": "Module",
        "More information": "Weitere Informationen",
        "More settings can be set in the Page Block Settings page": "Weitere Einstellungen können auf der Seite Seitenblock-Einstellungen vorgenommen werden",
        "Moved Permanently": "Permanent verschoben",
        "Multi-Status": "Multistatus",
        "Multiple Choices": "Mehrere Auswahlmöglichkeiten",
        "MUST START with 31, folliwing with number WITHOUT 0. Otherwise it won't work!": "MUSS mit 31 beginnen, gefolgt von der Nummer OHNE 0. Andernfalls funktioniert es nicht!",
        "Mute client": "Client stummschalten",
        "muted": "stummgeschaltet",
        "Muted": "Stummgeschaltet",
        "name": "name",
        "Name": "Name",
        "Name *": "Name *",
        "Name client": "Name des Clients",
        "Network Authentication Required": "Netzwerkauthentifizierung erforderlich",
        "Network Connect Timeout Error": "Zeitüberschreitungsfehler bei Netzwerkverbindung",
        "Network Read Timeout Error": "Zeitüberschreitungsfehler beim Lesen des Netzwerks",
        "New": "Neu",
        "New {name}": "Neu {name}",
        "New URL": "Neue URL",
        "News": "News",
        "News Content": "News-Inhalt",
        "Newsletter": "Newsletter",
        "No": "Nein",
        "No Content": "Kein Inhalt",
        "No items": "Keine Einträge",
        "Non-Authoritative Information": "Nicht maßgebende Informationen",
        "None": "Keine",
        "Normal": "Normal",
        "Not Acceptable": "Nicht akzeptierbar",
        "Not Extended": "Nicht erweitert",
        "Not Found": "Nicht gefunden",
        "Not Implemented": "Nicht implementiert",
        "Not implemented yet": "Noch nicht implementiert",
        "Not Modified": "Nicht modifiziert",
        "of": "von",
        "OK": "OK",
        "Old URL": "Alte URL",
        "On your phone or tablet with camera. We can advise you to use {google} or {microsoft}.": "Auf Ihrem Smartphone oder Tablet mit Kamera. Wir empfehlen Ihnen die Nutzung von {google} oder {microsoft}.",
        "Open": "Offen",
        "Open in a current window": "In einem aktuellen Fenster öffnen",
        "Open in a new window": "In einem neuen Fenster öffnen",
        "Open in a parent frame": "In einem übergeordneten Frame öffnen",
        "Open in the topmost frame": "Im obersten Rahmen öffnen",
        "Open on the website": "Auf der Website öffnen",
        "Open the authenticator app, add a new entry and scan the QR code": "Öffnen Sie die Authenticator-App, fügen Sie einen neuen Eintrag hinzu und scannen Sie den QR-Code",
        "Opening hours": "Öffnungszeiten",
        "Openings hours": "Öffnungszeiten",
        "Order": "Reihenfolge",
        "Origin Is Unreachable": "Quelle ist nicht erreichbar",
        "Overview": "Übersicht",
        "Overwrite title color": "Titelfarbe überschreiben",
        "Package name": "Paketname",
        "Packages": "Pakete",
        "Page (within website)": "Seite (innerhalb der Website)",
        "Page blocks": "Seitenblöcke",
        "Page Expired": "Seite abgelaufen",
        "Page Header": "Seiten-Header",
        "Page Title": "Seitentitel",
        "PageHeader": "PageHeader",
        "Pagination Navigation": "Seiten-Navigation",
        "Paragraph": "Absatz",
        "Parent category": "Übergeordnete Kategorie",
        "Partial Content": "Teilinhalt",
        "Password": "Passwort",
        "Paste in here only the Youtube ID. That id the ID what you see in the url in the browser after https://www.youtube.com/watch?v=": "Fügen Sie hier nur die YouTube-ID ein. Das ist die ID, die Sie in der URL des Browsers nach https://www.youtube.com/watch?v= sehen",
        "Paste or type the code we sent a code to your e-mail.": "Fügen Sie den Code ein oder geben Sie ihn ein, den wir an Ihre E-Mail-Adresse gesendet haben.",
        "Paste or type the code we sent a code to your phone number.": "Fügen Sie den Code ein oder geben Sie ihn ein, den wir an Ihre Telefonnummer gesendet haben.",
        "Payload Too Large": "Nutzlast zu groß",
        "Payment Required": "Zahlung erforderlich",
        "PDF Menu cards": "PDF-Speisekarten",
        "Permanent": "Permanent",
        "Permanent Redirect": "Permanente Weiterleitung",
        "Phone": "Telefon",
        "Phone *": "Telefon *",
        "phone number": "telefonnummer",
        "Phone number": "Telefonnummer",
        "phone_number": "phone_number",
        "Place": "Ort",
        "Please click the button below to verify your email address.": "Bitte klicken Sie auf die Schaltfläche, um Ihre E-Mail-Adresse zu bestätigen.",
        "plus icon": "plus-Symbol",
        "Postal code": "Postleitzahl",
        "Postcode": "Postleitzahl",
        "Precondition Failed": "Vorbedingung fehlgeschlagen",
        "Precondition Required": "Voraussetzung erforderlich",
        "Preview": "Vorschau",
        "Price": "Preis",
        "Price frequency": "Preishäufigkeit",
        "Primary": "Primär",
        "Primary Color": "Primärfarbe",
        "Primary Color (on dark backgrounds)": "Primärfarbe (auf dunklen Hintergründen)",
        "Primary Hover Color": "Primäre Hover-Farbe",
        "Primary Hover Color (on dark backgrounds)": "Primäre Hover-Farbe (auf dunklen Hintergründen)",
        "Primary text color": "Primäre Textfarbe",
        "Primary text color (on dark backgrounds)": "Primäre Textfarbe (auf dunklen Hintergründen)",
        "Print": "Drucken",
        "Priority": "Priorität",
        "Privacy declaration": "Datenschutzerklärung",
        "privacy statement": "Datenschutzerklärung",
        "Processing": "In Bearbeitung",
        "Product": "Produkt",
        "Products": "Produkte",
        "Project Content": "Projektinhalt",
        "Projects": "Projekte",
        "Proxy Authentication Required": "Proxy-Authentifizierung erforderlich",
        "Question": "Frage",
        "Railgun Error": "Railgun-Fehler",
        "Range Not Satisfiable": "Bereich nicht erfüllbar",
        "Reactivate": "Reaktivieren",
        "Read more": "Mehr lesen",
        "Record": "Aufzeichnen",
        "Regards": "Mit freundlichen Grüßen",
        "Regards,": "Mit freundlichen Grüßen,",
        "Register": "Registrieren",
        "Regular": "Regulär",
        "Related products": "Ähnliche Produkte",
        "Remove": "Entfernen",
        "Remove discount code": "Rabattcode entfernen",
        "Reopened subtask": "Wiedereröffnete Unteraufgabe",
        "Request Header Fields Too Large": "Anfrage-Header-Felder zu groß",
        "Request Timeout": "Zeitüberschreitung der Anfrage",
        "Resend {attribute}": "{attribute} erneut senden",
        "Reserved By": "Reserviert von",
        "Reset Content": "Inhalt zurücksetzen",
        "Reset Password": "Passwort zurücksetzen",
        "Reset Password Notification": "Benachrichtigung zum Zurücksetzen des Passworts",
        "Restore": "Wiederherstellen",
        "Restore {name}": "{name} wiederherstellen",
        "results": "Ergebnissen",
        "Results": "Ergebnisse",
        "Results are shared": "Ergebnisse werden geteilt",
        "Retry With": "Wiederhole mit",
        "Review": "Bewertung",
        "Review slider": "Bewertungs-Slider",
        "Review Slider": "Bewertungs-Slider",
        "Reviews": "Bewertungen",
        "Reviewslider": "Bewertungsslider",
        "role": "Rolle",
        "Role": "Rolle",
        "Roles": "Rollen",
        "Rounded": "Abgerundet",
        "Sampled at": "Erfasst am",
        "Save": "Speichern",
        "Save {name}": "Sparen Sie {name}",
        "Save & Close": "Speichern und schließen",
        "Save & Return": "Speichern und zurückgeben",
        "Save these codes on a secure place if you can’t get access with your Authenticator app.": "Speichern Sie diese Codes an einem sicheren Ort, falls Sie mit Ihrer Authenticator-App keinen Zugriff erhalten.",
        "Scan the QR code": "Scannen Sie den QR-Code",
        "Scanning not possible? Fill in this code in the app.": "Scannen nicht möglich? Geben Sie diesen Code in der App ein.",
        "Search": "Suchen",
        "Search {name}": "Suche {name}",
        "Secondary": "Sekundär",
        "Secondary Color": "Sekundärfarbe",
        "See all faqs": "Alle FAQs ansehen",
        "See Other": "Siehe andere Seite",
        "Select": "Wählen Sie",
        "Select a {model}": "Wählen Sie ein {model}",
        "Select a template to add the corresponding blocks.": "Wählen Sie eine Vorlage, um die entsprechenden Blöcke hinzuzufügen.",
        "Select a template to add the corresponding blocks. Note that this cannot be changed after page has been created": "Wählen Sie eine Vorlage, um die entsprechenden Blöcke hinzuzufügen. Beachten Sie, dass dies nach der Erstellung der Seite nicht mehr geändert werden kann",
        "Select a test": "Wählen Sie einen Test",
        "Select a type": "Wählen Sie einen Typ",
        "Select All": "Wählen Sie Alle",
        "Send": "Schicken",
        "Send application": "Bewerbung senden",
        "SEO Description": "SEO-Beschreibung",
        "SEO Settings for {lang}": "SEO-Einstellungen für {lang}",
        "SEO title": "SEO-Titel",
        "Server Error": "Interner Fehler",
        "Service Unavailable": "Service nicht verfügbar",
        "Services": "Dienstleistungen",
        "Session Has Expired": "Sitzung ist abgelaufen",
        "Set all titles to uppercase": "Alle Titel in Großbuchstaben setzen",
        "Set color for the footer background": "Farbe für den Footer-Hintergrund festlegen",
        "Set color for the footer text": "Farbe für den Footer-Text festlegen",
        "Set color for the footer.": "Farbe für den Footer festlegen.",
        "Set Two Factor Authentication": "Zwei-Faktor-Authentifizierung einrichten",
        "Sets": "Sätze",
        "Settings": "Einstellungen",
        "Share results": "Ergebnisse teilen",
        "shared": "geteilt",
        "Shipping address same as billing address": "Lieferadresse entspricht der Rechnungsadresse",
        "Shipping method": "Versandmethode",
        "Shop": "Shop",
        "Shop not finished yet...": "Shop noch nicht fertig...",
        "shopping cart": "Warenkorb",
        "Shopping cart": "Warenkorb",
        "Show": "Zeigen",
        "Show {name}": "{name} anzeigen",
        "Show All": "Zeige alles",
        "Show opening hours in header": "Öffnungszeiten im Header anzeigen",
        "Show phone number in header": "Telefonnummer im Header anzeigen",
        "Showing": "Zeige",
        "Sign In": "Anmelden",
        "Sign out": "Abmelden",
        "Slug": "Slug",
        "Social media": "Soziale Medien",
        "Solve": "Lösen",
        "SSL Handshake Failed": "SSL Handshake fehlgeschlagen",
        "Stars": "Sterne",
        "Start": "Starten",
        "Start date:": "Startdatum:",
        "Started at": "Gestartet um",
        "Status": "Status",
        "Statuses": "Status",
        "Stop": "Stoppen",
        "Street name": "Straßenname",
        "Street number": "Hausnummer",
        "Street number addition": "Hausnummerzusatz",
        "Subject": "Betreff",
        "Subject *": "Betreff *",
        "Submit": "Einreichen",
        "Subscribe": "Abonnieren",
        "SubTasks": "Unteraufgaben",
        "Subtotal": "Zwischensumme",
        "Switch": "Wechseln",
        "Switch To Role": "Zur Rolle wechseln",
        "Switching Protocols": "Protokollwechsel",
        "Tag": "Stichwort",
        "Tags": "Stichworte",
        "Task": "Aufgabe",
        "Tasks": "Aufgaben",
        "Team": "Team",
        "Temporary Redirect": "Temporäre Weiterleitung",
        "terms and conditions": "Allgemeine Geschäftsbedingungen",
        "Terms and Conditions": "Allgemeine Geschäftsbedingungen",
        "Tertiary": "Tertiär",
        "Tertiary Color": "Tertiärfarbe",
        "test": "Test",
        "Test": "Test",
        "test set": "Testsatz",
        "Test set": "Testsatz",
        "Test sets": "Testsätze",
        "Tests": "Tests",
        "Text": "Text",
        "Text transform": "Textumwandlung",
        "Thank you for your application!": "Vielen Dank für Ihre Bewerbung!",
        "Thank you for your application. We will contact you shortly.": "Vielen Dank für Ihre Bewerbung. Wir werden uns in Kürze bei Ihnen melden.",
        "Thank you for your message!": "Vielen Dank für Ihre Nachricht!",
        "Thank you for your sign up!": "Vielen Dank für Ihre Anmeldung!",
        "The {attribute} has already been taken.": "{attribute} ist bereits vergeben.",
        "The {attribute} must be verified.": "{attribute} muss verifiziert werden.",
        "The {attribute} must contain at least one letter.": "{attribute} muss mindestens einen Buchstaben enthalten.",
        "The {attribute} must contain at least one number.": "{attribute} muss mindestens eine Zahl enthalten.",
        "The {attribute} must contain at least one symbol.": "{attribute} muss mindestens ein Symbol enthalten.",
        "The {attribute} must contain at least one uppercase and one lowercase letter.": "{attribute} muss mindestens einen Großbuchstaben und einen Kleinbuchstaben enthalten.",
        "The content of this block in the language you are editing is replaced. The other languages are left alone.": "Der Inhalt dieses Blocks in der Sprache, die du bearbeitest, wird ersetzt. Die anderen Sprachen bleiben unberührt.",
        "The coupon has already been used.": "Der Gutschein wurde bereits verwendet.",
        "The coupon has expired.": "Der Gutschein ist abgelaufen.",
        "The font size for the main / body font.": "Die Schriftgröße für die Haupt- / Fließtextschrift.",
        "The given {attribute} has appeared in a data leak. Please choose a different {attribute}.": "Das angegebene {attribute} ist in einem Datenleck aufgetaucht. Bitte wählen Sie ein anderes {attribute}.",
        "The given data was invalid.": "Die gegebenen Daten waren ungültig.",
        "The image of the language you are editing is replaced. The other languages are left alone.": "Das Bild der Sprache, die du bearbeitest, wird ersetzt. Die anderen Sprachen bleiben unberührt.",
        "The provided {attribute} is invalid.": "Das angegebene {attribute} ist ungültig.",
        "The provided code was invalid.": "Der angegebene Code war ungültig.",
        "The provided password does not match your current password.": "Das angegebene Passwort stimmt nicht mit Ihrem aktuellen Passwort überein.",
        "The provided two factor authentication code was invalid.": "Der angegebene Zwei-Faktor-Authentifizierungscode war ungültig.",
        "The response is not a streamed response.": "Die Antwort ist keine gestreamte Antwort.",
        "The response is not a view.": "Die Antwort ist keine Ansicht.",
        "The styling for all mails like contactform, newsletter etc.": "Das Styling für alle E-Mails wie Kontaktformular, Newsletter usw.",
        "The tests cannot be changed once the test set is created.": "Die Tests können nicht mehr geändert werden, sobald das Testset erstellt wurde.",
        "The text color for primary elements, like buttons": "Die Textfarbe für primäre Elemente, wie Schaltflächen",
        "The text color for primary elements, like buttons on a dark background": "Die Textfarbe für primäre Elemente, wie Schaltflächen auf einem dunklen Hintergrund",
        "The thickness of the font that will be displayed": "Die Dicke der Schriftart, die angezeigt wird",
        "The thickness of the font that will be displayed for all heading titles": "Die Dicke der Schriftart, die für alle Überschriftentitel angezeigt wird",
        "This {attribute} has already been used": "{attribute} wurde bereits verwendet",
        "This action is unauthorized.": "Diese Aktion ist nicht autorisiert.",
        "This area is restricted to medical medic members only.": "Dieser Bereich ist ausschließlich medizinischen Medic-Mitgliedern vorbehalten.",
        "This area is restricted to staff members only.": "Dieser Bereich ist ausschließlich Mitarbeitern vorbehalten.",
        "This changes every language": "Dies ändert alle Sprachen",
        "This font will be used as main / body font.": "Diese Schriftart wird als Haupt- / Fließtextschrift verwendet.",
        "This font will be used for all heading titles H1, H2, H3. H4, H5, H6": "Diese Schriftart wird für alle Überschriftentitel H1, H2, H3. H4, H5, H6 verwendet",
        "This is your first login": "Dies ist Ihre erste Anmeldung",
        "This line must be as short as possible, otherwise the menu items won't fit at 1 line": "Diese Zeile muss so kurz wie möglich sein, sonst passen die Menüpunkte nicht in eine Zeile",
        "This link expires in {number} hours": "Dieser Link läuft in {number} Stunden ab",
        "This password reset link will expire in {count} minutes.": "Dieser Link zum Zurücksetzen des Passworts läuft in {count} Minuten ab.",
        "This task is reserved by {userName}": "Diese Aufgabe ist reserviert von {userName}",
        "This task is reserved by {userName}.": "Diese Aufgabe ist reserviert von {userName}.",
        "title": "titel",
        "Title": "Titel",
        "to": "bis",
        "To use Top Chefs Two Factor Authentication is required as extra security, you can set this now": "Um Top Chefs zu nutzen, ist eine Zwei-Faktor-Authentifizierung als zusätzliche Sicherheit erforderlich. Sie können dies jetzt einrichten",
        "TODO": "TODO",
        "Toggle navigation": "Navigation umschalten",
        "token": "token",
        "Too Early": "Zu früh",
        "Too Many Requests": "Zu viele Anfragen",
        "Total": "Gesamt",
        "Trans": "Trans",
        "Translate": "Übersetzen",
        "Translate It": "Übersetze es",
        "Two Factor Authentication - Backup codes": "Zwei-Faktor-Authentifizierung - Backup-Codes",
        "Type": "Typ",
        "Type job position": "Jobposition eingeben",
        "Unauthorized": "Nicht autorisiert",
        "Unavailable For Legal Reasons": "Aus rechtlichen Gründen nicht verfügbar",
        "Underline": "Unterstreichen",
        "Unknown Error": "Unbekannter Fehler",
        "Unmute client": "Stummschaltung des Clients aufheben",
        "unmuted": "nicht stummgeschaltet",
        "Unpack": "Auspacken",
        "Unprocessable Entity": "Unverarbeitbare Entität",
        "Unsubscribe": "Abbestellen",
        "Unsupported Media Type": "Nicht unterstützter Medientyp",
        "Up": "Hoch",
        "Update": "Aktualisieren",
        "Update {name}": "{name} aktualisieren",
        "updated": "aktualisiert",
        "Upgrade Required": "Upgrade erforderlich",
        "Upload C.V *": "Lebenslauf hochladen *",
        "Upload cover letter *": "Anschreiben hochladen *",
        "Upload CV *": "Lebenslauf hochladen *",
        "Upload Motivation *": "Motivationsschreiben hochladen *",
        "Uppercase": "Großbuchstaben",
        "URI Too Long": "URI ist zu lang",
        "url": "url",
        "Url": "Url",
        "Use Proxy": "Proxy verwenden",
        "user": "Benutzer",
        "User": "Benutzer",
        "users": "Benutzer",
        "Users": "Benutzer",
        "USPs": "USPs",
        "Uw winkelmand is leeg": "Ihr Warenkorb ist leer",
        "Vacancies": "Stellenangebote",
        "Vacancies Overview": "Übersicht der Stellenangebote",
        "Vacancy application form": "Bewerbungsformular für Stellenangebote",
        "Vacancy Content": "Inhalt des Stellenangebots",
        "Vacancy intro": "Einführung zum Stellenangebot",
        "Vacancy recent": "Aktuelle Stellenangebote",
        "Vacancyfilters": "Stellenfilter",
        "Variant Also Negotiates": "Variante verhandelt ebenfalls",
        "Variants": "Varianten",
        "VAT": "MwSt.",
        "Verify": "Überprüfen",
        "Verify {attribute}": "Überprüfen Sie {attribute}",
        "Verify Email Address": "E-Mail-Adresse bestätigen",
        "Videos": "Videos",
        "view": "anzeigen",
        "View": "Ansicht",
        "View {name}": "Ansicht {name}",
        "view all": "alle anzeigen",
        "View all": "Alle anzeigen",
        "View project": "Projekt anzeigen",
        "View vacancy": "Stellenangebot anzeigen",
        "We have done our best, but it seems that the page you requested does not exist (anymore) or that it may have moved.": "Wir haben unser Bestes getan, aber es scheint, dass die von Ihnen angeforderte Seite nicht (mehr) existiert oder verschoben wurde.",
        "We have received your message. One of our employees will contact you as soon as possible.": "Wir haben Ihre Nachricht erhalten. Einer unserer Mitarbeiter wird sich so schnell wie möglich mit Ihnen in Verbindung setzen.",
        "Web Page": "Webseite",
        "Web Page Settings": "Webseiten-Einstellungen",
        "Web Server is Down": "Webserver ist ausgefallen",
        "weekly": "wöchentlich",
        "Welcome": "Willkommen",
        "Welcome to {page}": "Willkommen bei {page}",
        "WhatsApp Button": "WhatsApp-Schaltfläche",
        "Whatsapp number": "WhatsApp-Nummer",
        "When enabled, an email will be sent to the user, letting them know their account has been created.": "Wenn aktiviert, wird eine E-Mail an den Benutzer gesendet, um ihn darüber zu informieren, dass sein Konto erstellt wurde.",
        "Which blocks a page has is shared between languages, so adding or removing one here does the same in the other languages. Only the content inside a block belongs to the language you are editing.": "Welche Blöcke eine Seite hat, wird von allen Sprachen geteilt: Einen Block hier hinzuzufügen oder zu entfernen tut dasselbe in den anderen Sprachen. Nur die Inhalte innerhalb eines Blocks gehören zur Sprache, die du bearbeitest.",
        "White": "Weiß",
        "Whoops!": "Ups!",
        "Will be used as color for the titles": "Wird als Farbe für die Titel verwendet",
        "Will be used as hover main color for buttons, links, elements or components with a background color": "Wird als Hover-Hauptfarbe für Schaltflächen, Links, Elemente oder Komponenten mit einer Hintergrundfarbe verwendet",
        "Will be used as hover main color on a dark background": "Wird als Hover-Hauptfarbe auf einem dunklen Hintergrund verwendet",
        "Will be used as main color for buttons, links, elements or components with a background color": "Wird als Hauptfarbe für Schaltflächen, Links, Elemente oder Komponenten mit einer Hintergrundfarbe verwendet",
        "Will be used as main color for the body text": "Wird als Hauptfarbe für den Fließtext verwendet",
        "Will be used as main color on a dark background": "Wird als Hauptfarbe auf einem dunklen Hintergrund verwendet",
        "Yes": "Ja",
        "You are receiving this email because we received a password reset request for your account.": "Sie erhalten diese E-Mail, weil wir einen Antrag auf eine Zurücksetzung Ihres Passworts bekommen haben.",
        "You can contact us via the form. We look forward to hearing from you. Have you looked at the frequently asked questions? With the exception of weekends and holidays, we try to send you a response to your questions within 24 hours.": "Sie können uns über das Formular kontaktieren. Wir freuen uns auf Ihre Nachricht. Haben Sie sich schon die häufig gestellten Fragen angesehen? Mit Ausnahme von Wochenenden und Feiertagen versuchen wir, Ihnen innerhalb von 24 Stunden eine Antwort auf Ihre Fragen zu senden.",
        "You will receive this email because your account is ready for {siteName}": "Sie erhalten diese E-Mail, weil Ihr Konto für {siteName} bereit ist",
        "Your account for {siteName}": "Ihr Konto für {siteName}",
        "Your account is inactive. Please contact support.": "Ihr Konto ist inaktiv. Bitte kontaktieren Sie den Support.",
        "Your account is inactive. Please contact support. To use the website as a guest, please refresh the page.": "Ihr Konto ist inaktiv. Bitte kontaktieren Sie den Support. Um die Website als Gast zu nutzen, aktualisieren Sie bitte die Seite.",
        "Your current locale is {locale}": "Ihre aktuelle Spracheinstellung ist {locale}",
        "Your last login was {relativeTime} on {dateTime}": "Ihre letzte Anmeldung war {relativeTime} am {dateTime}",
        "Your order": "Ihre Bestellung",
        "Your Order": "Ihre Bestellung",
        "Your Profile": "Ihr Profil",
        "Youtube": "Youtube",
        "Youtube Video ID": "Youtube Video-ID",
        "auth": {
            "failed": "Diese Kombination aus Zugangsdaten wurde nicht in unserer Datenbank gefunden.",
            "password": "Das Passwort ist falsch.",
            "throttle": "Zu viele Loginversuche. Versuchen Sie es bitte in {seconds} Sekunden nochmal."
        },
        "actions": {
            "accept": "Akzeptieren",
            "action": "Aktion",
            "actions": "Aktionen",
            "add": "Hinzufügen",
            "admin": "Administrator",
            "agree": "Zustimmen",
            "archive": "Archiv",
            "assign": "Zuordnen",
            "associate": "Assoziieren",
            "attach": "Anfügen",
            "browse": "Durchsuche",
            "cancel": "Stornieren",
            "choose": "Wählen",
            "choose_file": "Datei wählen",
            "choose_image": "Wählen Sie Bild",
            "click_to_copy": "Klicken Sie zum Kopieren",
            "close": "Schließen",
            "collapse": "Zusammenbruch",
            "collapse_all": "Alles reduzieren",
            "comment": "Kommentar",
            "confirm": "Bestätigen",
            "connect": "Verbinden",
            "create": "Erstellen",
            "delete": "Löschen",
            "detach": "Ablösen",
            "details": "Einzelheiten",
            "disable": "Deaktivieren",
            "discard": "Verwerfen",
            "done": "Erledigt",
            "down": "Runter",
            "duplicate": "Duplikat",
            "edit": "Bearbeiten",
            "enable": "Aktivieren",
            "expand": "Expandieren",
            "expand_all": "Alle erweitern",
            "explanation": "Erläuterung",
            "export": "Exportieren",
            "file": "Datei",
            "files": "Dateien",
            "go_home": "Nach Hause gehen",
            "hide": "Verstecken",
            "home": "Heim",
            "image": "Bild",
            "impersonate": "Imitieren",
            "impersonation": "Identitätswechsel",
            "import": "Importieren",
            "introduction": "Einführung",
            "like": "Wie",
            "load": "Belastung",
            "localize": "Lokalisieren",
            "log_in": "Anmeldung",
            "log_out": "Ausloggen",
            "named": {
                "add": "{name} hinzufügen",
                "choose": "{name} auswählen",
                "create": "{name} erstellen",
                "delete": "{name} löschen",
                "duplicate": "{name} duplizieren",
                "edit": "{name} bearbeiten",
                "export": "{name} exportieren",
                "hide": "{name} ausblenden",
                "import": "{name} importieren",
                "new": "Neu {name}",
                "restore": "{name} wiederherstellen",
                "save": "{name} speichern",
                "search": "{name} suchen",
                "show": "{name} anzeigen",
                "update": "{name} aktualisieren",
                "view": "{name} anzeigen"
            },
            "new": "Neu",
            "no": "Nein",
            "open": "Öffen",
            "open_website": "Auf der Website öffnen",
            "preview": "Vorschau",
            "price": "Preis",
            "record": "Aufzeichnen",
            "restore": "Wiederherstellen",
            "save": "Speichern",
            "save_and_close": "Speichern und schließen",
            "save_and_return": "Speichern und zurückgehen",
            "search": "Suchen",
            "select": "Wählen",
            "select_all": "Alles auswählen",
            "send": "Absenden",
            "settings": "Einstellungen",
            "show": "Anzeigen",
            "show_all": "Alles anzeigen",
            "sign_in": "Anmelden",
            "solve": "Lösen",
            "start": "Starten",
            "stop": "Stoppen",
            "submit": "Absenden",
            "subscribe": "Abonnieren",
            "switch": "Umschalten",
            "switch_to_role": "Zur Rolle wechseln",
            "tag": "Schlagwort",
            "tags": "Stichworte",
            "target_link": {
                "blank": "In einem neuen Fenster öffnen",
                "parent": "In einem übergeordneten Frame öffnen",
                "self": "In einem aktuellen Fenster öffnen",
                "top": "Im obersten Rahmen öffnen"
            },
            "translate": "Übersetzen",
            "translate_it": "Übersetze es",
            "unpack": "Entpacken",
            "unsubscribe": "Abbestellen",
            "up": "Hoch",
            "update": "Aktualisieren",
            "user": "Benutzer",
            "view": "Ansicht",
            "yes": "Ja"
        },
        "validation": {
            "accepted": "{Attribute} muss akzeptiert werden.",
            "accepted_if": "{Attribute} muss akzeptiert werden, wenn {other} {value} ist.",
            "active_url": "{Attribute} ist keine gültige Internet-Adresse.",
            "after": "{Attribute} muss ein Datum nach {date} sein.",
            "after_or_equal": "{Attribute} muss ein Datum nach {date} oder gleich {date} sein.",
            "alpha": "{Attribute} darf nur aus Buchstaben bestehen.",
            "alpha_dash": "{Attribute} darf nur aus Buchstaben, Zahlen, Binde- und Unterstrichen bestehen.",
            "alpha_num": "{Attribute} darf nur aus Buchstaben und Zahlen bestehen.",
            "any_of": "{Attribute} ist ungültig.",
            "array": "{Attribute} muss ein Array sein.",
            "ascii": "Die {attribute} darf nur alphanumerische Single-Byte-Zeichen und -Symbole enthalten.",
            "before": "{Attribute} muss ein Datum vor {date} sein.",
            "before_or_equal": "{Attribute} muss ein Datum vor {date} oder gleich {date} sein.",
            "between": {
                "array": "{Attribute} muss zwischen {min} & {max} Elemente haben.",
                "file": "{Attribute} muss zwischen {min} & {max} Kilobytes groß sein.",
                "numeric": "{Attribute} muss zwischen {min} & {max} liegen.",
                "string": "{Attribute} muss zwischen {min} & {max} Zeichen lang sein."
            },
            "boolean": "{Attribute} muss entweder 'true' oder 'false' sein.",
            "can": "Das Feld {attribute} enthält einen nicht autorisierten Wert.",
            "confirmed": "{Attribute} stimmt nicht mit der Bestätigung überein.",
            "contains": "Dem Feld {attribute} fehlt ein erforderlicher Wert.",
            "current_password": "Das Passwort ist falsch.",
            "date": "{Attribute} muss ein gültiges Datum sein.",
            "date_equals": "{Attribute} muss ein Datum gleich {date} sein.",
            "date_format": "{Attribute} entspricht nicht dem gültigen Format für {format}.",
            "decimal": "Die {attribute} muss {decimal} Dezimalstellen haben.",
            "declined": "{Attribute} muss abgelehnt werden.",
            "declined_if": "{Attribute} muss abgelehnt werden wenn {other} {value} ist.",
            "different": "{Attribute} und {other} müssen sich unterscheiden.",
            "digits": "{Attribute} muss {digits} Stellen haben.",
            "digits_between": "{Attribute} muss zwischen {min} und {max} Stellen haben.",
            "dimensions": "{Attribute} hat ungültige Bildabmessungen.",
            "distinct": "{Attribute} beinhaltet einen bereits vorhandenen Wert.",
            "doesnt_contain": "{Attribute} darf keines der folgenden enthalten: {values}.",
            "doesnt_end_with": "{Attribute} darf nicht mit einem der folgenden enden: {values}.",
            "doesnt_start_with": "{Attribute} darf nicht mit einem der folgenden beginnen: {values}.",
            "email": "{Attribute} muss eine gültige E-Mail-Adresse sein.",
            "encoding": "{Attribute} muss als {encoding} kodiert sein.",
            "ends_with": "{Attribute} muss eine der folgenden Endungen aufweisen: {values}",
            "enum": "Der ausgewählte Wert ist ungültig.",
            "exists": "Der gewählte Wert für {attribute} ist ungültig.",
            "extensions": "Das Feld {attribute} muss eine der folgenden Erweiterungen haben: {values}.",
            "file": "{Attribute} muss eine Datei sein.",
            "filled": "{Attribute} muss ausgefüllt sein.",
            "gt": {
                "array": "{Attribute} muss mehr als {value} Elemente haben.",
                "file": "{Attribute} muss größer als {value} Kilobytes sein.",
                "numeric": "{Attribute} muss größer als {value} sein.",
                "string": "{Attribute} muss länger als {value} Zeichen sein."
            },
            "gte": {
                "array": "{Attribute} muss mindestens {value} Elemente haben.",
                "file": "{Attribute} muss größer oder gleich {value} Kilobytes sein.",
                "numeric": "{Attribute} muss größer oder gleich {value} sein.",
                "string": "{Attribute} muss mindestens {value} Zeichen lang sein."
            },
            "hex_color": "Das Feld {attribute} muss eine gültige Hexadezimalfarbe sein.",
            "image": "{Attribute} muss ein Bild sein.",
            "in": "Der gewählte Wert für {attribute} ist ungültig.",
            "in_array": "Der gewählte Wert für {attribute} kommt nicht in {other} vor.",
            "in_array_keys": "Das Feld {Attribute} muss mindestens einen der folgenden Schlüssel enthalten: {Values}.",
            "integer": "{Attribute} muss eine ganze Zahl sein.",
            "ip": "{Attribute} muss eine gültige IP-Adresse sein.",
            "ipv4": "{Attribute} muss eine gültige IPv4-Adresse sein.",
            "ipv6": "{Attribute} muss eine gültige IPv6-Adresse sein.",
            "json": "{Attribute} muss ein gültiger JSON-String sein.",
            "list": "{Attribute} muss eine Liste sein.",
            "lowercase": "{Attribute} muss in Kleinbuchstaben sein.",
            "lt": {
                "array": "{Attribute} muss weniger als {value} Elemente haben.",
                "file": "{Attribute} muss kleiner als {value} Kilobytes sein.",
                "numeric": "{Attribute} muss kleiner als {value} sein.",
                "string": "{Attribute} muss kürzer als {value} Zeichen sein."
            },
            "lte": {
                "array": "{Attribute} darf maximal {value} Elemente haben.",
                "file": "{Attribute} muss kleiner oder gleich {value} Kilobytes sein.",
                "numeric": "{Attribute} muss kleiner oder gleich {value} sein.",
                "string": "{Attribute} darf maximal {value} Zeichen lang sein."
            },
            "mac_address": "Der Wert muss eine gültige MAC-Adresse sein.",
            "max": {
                "array": "{Attribute} darf maximal {max} Elemente haben.",
                "file": "{Attribute} darf maximal {max} Kilobytes groß sein.",
                "numeric": "{Attribute} darf maximal {max} sein.",
                "string": "{Attribute} darf maximal {max} Zeichen haben."
            },
            "max_digits": "{Attribute} darf maximal {max} Ziffern lang sein.",
            "mimes": "{Attribute} muss den Dateityp {values} haben.",
            "mimetypes": "{Attribute} muss den Dateityp {values} haben.",
            "min": {
                "array": "{Attribute} muss mindestens {min} Elemente haben.",
                "file": "{Attribute} muss mindestens {min} Kilobytes groß sein.",
                "numeric": "{Attribute} muss mindestens {min} sein.",
                "string": "{Attribute} muss mindestens {min} Zeichen lang sein."
            },
            "min_digits": "{Attribute} muss mindestens {min} Ziffern lang sein.",
            "missing": "Das Feld {attribute} muss fehlen.",
            "missing_if": "Das Feld {attribute} muss fehlen, wenn {other} gleich {value} ist.",
            "missing_unless": "Das Feld {attribute} muss fehlen, es sei denn, {other} ist {value}.",
            "missing_with": "Das Feld {attribute} muss fehlen, wenn {values} vorhanden ist.",
            "missing_with_all": "Das Feld {attribute} muss fehlen, wenn {values} vorhanden sind.",
            "multiple_of": "{Attribute} muss ein Vielfaches von {value} sein.",
            "not_in": "Der gewählte Wert für {attribute} ist ungültig.",
            "not_regex": "{Attribute} hat ein ungültiges Format.",
            "numeric": "{Attribute} muss eine Zahl sein.",
            "password": {
                "letters": "{Attribute} muss mindestens einen Buchstaben beinhalten.",
                "mixed": "{Attribute} muss mindestens einen Großbuchstaben und einen Kleinbuchstaben beinhalten.",
                "numbers": "{Attribute} muss mindestens eine Zahl beinhalten.",
                "symbols": "{Attribute} muss mindestens ein Sonderzeichen beinhalten.",
                "uncompromised": "{Attribute} wurde in einem Datenleck gefunden. Bitte wählen Sie ein anderes {attribute}."
            },
            "present": "{Attribute} muss vorhanden sein.",
            "present_if": "Das Feld {attribute} muss vorhanden sein, wenn {other} gleich {value} ist.",
            "present_unless": "Das Feld {attribute} muss vorhanden sein, es sei denn, {other} ist {value}.",
            "present_with": "Das Feld {attribute} muss vorhanden sein, wenn {values} vorhanden ist.",
            "present_with_all": "Das Feld {attribute} muss vorhanden sein, wenn {values} vorhanden sind.",
            "prohibited": "{Attribute} ist unzulässig.",
            "prohibited_if": "{Attribute} ist unzulässig, wenn {other} {value} ist.",
            "prohibited_if_accepted": "Das Feld {attribute} ist unzulässig, wenn {other} gewählt ist.",
            "prohibited_if_declined": "Das Feld {attribute} ist unzulässig, wenn {other} abgelehnt ist.",
            "prohibited_unless": "{Attribute} ist unzulässig, wenn {other} nicht {values} ist.",
            "prohibits": "{Attribute} verbietet die Angabe von {other}.",
            "regex": "{Attribute} Format ist ungültig.",
            "required": "{Attribute} muss ausgefüllt werden.",
            "required_array_keys": "Dieses Feld muss Einträge enthalten für: {values}.",
            "required_if": "{Attribute} muss ausgefüllt werden, wenn {other} den Wert {value} hat.",
            "required_if_accepted": "{Attribute} muss ausgefüllt werden, wenn {other} gewählt ist.",
            "required_if_declined": "Das Feld {attribute} ist erforderlich, wenn {other} abgelehnt wird.",
            "required_unless": "{Attribute} muss ausgefüllt werden, wenn {other} nicht den Wert {values} hat.",
            "required_with": "{Attribute} muss ausgefüllt werden, wenn {values} ausgefüllt wurde.",
            "required_with_all": "{Attribute} muss ausgefüllt werden, wenn {values} ausgefüllt wurde.",
            "required_without": "{Attribute} muss ausgefüllt werden, wenn {values} nicht ausgefüllt wurde.",
            "required_without_all": "{Attribute} muss ausgefüllt werden, wenn keines der Felder {values} ausgefüllt wurde.",
            "same": "{Attribute} und {other} müssen übereinstimmen.",
            "size": {
                "array": "{Attribute} muss genau {size} Elemente haben.",
                "file": "{Attribute} muss {size} Kilobyte groß sein.",
                "numeric": "{Attribute} muss gleich {size} sein.",
                "string": "{Attribute} muss {size} Zeichen lang sein."
            },
            "starts_with": "{Attribute} muss mit einem der folgenden Anfänge aufweisen: {values}",
            "string": "{Attribute} muss ein String sein.",
            "timezone": "{Attribute} muss eine gültige Zeitzone sein.",
            "ulid": "Die {attribute} muss eine gültige ULID sein.",
            "unique": "{Attribute} ist bereits vergeben.",
            "uploaded": "{Attribute} konnte nicht hochgeladen werden.",
            "uppercase": "{Attribute} muss in Großbuchstaben sein.",
            "url": "{Attribute} muss eine URL sein.",
            "uuid": "{Attribute} muss ein UUID sein.",
            "attributes": {
                "address": "Adresse",
                "affiliate_url": "Affiliate-URL",
                "age": "Alter",
                "amount": "Höhe",
                "announcement": "Bekanntmachung",
                "area": "Gebiet",
                "audience_prize": "Publikumspreis",
                "audience_winner": "Publikumsgewinner",
                "available": "Verfügbar",
                "birthday": "Geburtstag",
                "body": "Körper",
                "city": "Stadt",
                "color": "Farbe",
                "company": "Unternehmen",
                "compilation": "Zusammenstellung",
                "concept": "Konzept",
                "conditions": "Bedingungen",
                "content": "Inhalt",
                "contest": "Wettbewerb",
                "country": "Land",
                "cover": "Abdeckung",
                "created_at": "Erstellt am",
                "creator": "Ersteller",
                "currency": "Währung",
                "current_password": "Derzeitiges Passwort",
                "customer": "Kunde",
                "date": "Datum",
                "date_of_birth": "Geburtsdatum",
                "dates": "Termine",
                "day": "Tag",
                "deleted_at": "Gelöscht am",
                "description": "Beschreibung",
                "display_type": "Anzeigetyp",
                "district": "Bezirk",
                "duration": "Dauer",
                "email": "E-Mail-Adresse",
                "excerpt": "Auszug",
                "filter": "Filter",
                "finished_at": "fertig um",
                "first_name": "Vorname",
                "gender": "Geschlecht",
                "grand_prize": "Hauptpreis",
                "group": "Gruppe",
                "hour": "Stunde",
                "image": "Bild",
                "image_desktop": "Desktop-Bild",
                "image_main": "Hauptbild",
                "image_mobile": "mobiles Bild",
                "images": "Bilder",
                "is_audience_winner": "ist Publikumssieger",
                "is_hidden": "ist versteckt",
                "is_subscribed": "ist abonniert",
                "is_visible": "ist sichtbar",
                "is_winner": "ist Gewinner",
                "items": "Artikel",
                "key": "Schlüssel",
                "last_name": "Nachname",
                "lesson": "Lektion",
                "line_address_1": "Adresszeile 1",
                "line_address_2": "Adresszeile 2",
                "login": "Anmeldung",
                "message": "Nachricht",
                "middle_name": "Zweitname",
                "minute": "Minute",
                "mobile": "Handynummer",
                "month": "Monat",
                "name": "Name",
                "national_code": "Länderkennung",
                "number": "Nummer",
                "password": "Passwort",
                "password_confirmation": "Passwortbestätigung",
                "phone": "Telefonnummer",
                "photo": "Foto",
                "portfolio": "Portfolio",
                "postal_code": "Postleitzahl",
                "preview": "Vorschau",
                "price": "Preis",
                "product_id": "Produkt ID",
                "product_uid": "Produkt-UID",
                "product_uuid": "Produkt-UUID",
                "promo_code": "Aktionscode",
                "province": "Provinz",
                "quantity": "Menge",
                "reason": "Grund",
                "recaptcha_response_field": "Captcha-Feld",
                "referee": "Schiedsrichter",
                "referees": "Schiedsrichter",
                "region": "Region",
                "reject_reason": "Ablehnungsgrund",
                "remember": "Erinnern",
                "restored_at": "Wiederhergestellt am",
                "result_text_under_image": "Ergebnistext unter Bild",
                "role": "Rolle",
                "rule": "Regel",
                "rules": "Regeln",
                "second": "Sekunde",
                "sex": "Geschlecht",
                "shipment": "Sendung",
                "short_text": "Kurzer Text",
                "size": "Größe",
                "skills": "Fähigkeiten",
                "slug": "Schnecke",
                "specialization": "Spezialisierung",
                "started_at": "fing an bei",
                "state": "Bundesland",
                "status": "Status",
                "street": "Straße",
                "student": "Schüler/Student",
                "subject": "Gegenstand",
                "tag": "Etikett",
                "tags": "Stichworte",
                "teacher": "Lehrer",
                "terms": "Bedingungen",
                "test_description": "Test Beschreibung",
                "test_locale": "Test Region",
                "test_name": "Testname",
                "text": "Text",
                "time": "Uhrzeit",
                "title": "Titel",
                "type": "Typ",
                "updated_at": "Aktualisiert am",
                "user": "Benutzer",
                "username": "Benutzername",
                "value": "Wert",
                "winner": "Gewinner",
                "work": "Arbeit",
                "year": "Jahr",
                "cv": "Lebenslauf",
                "locale": "Sprache",
                "motivation": "Motivationsschreiben",
                "order": "Bestellung",
                "place": "Wohnort",
                "url": "URL",
                "vacancy_id": "Stelle"
            }
        },
        "http-statuses": {
            "0": "Unbekannter Fehler",
            "100": "Weiter",
            "101": "Protokollwechsel",
            "102": "In Bearbeitung",
            "200": "OK",
            "201": "Erstellt",
            "202": "Akzeptiert",
            "203": "Nicht verifizierte Information",
            "204": "Kein Inhalt",
            "205": "Inhalt zurücksetzen",
            "206": "Teilinhalt",
            "207": "Multistatus",
            "208": "Bereits gemeldet",
            "226": "IM verwendet",
            "300": "Mehrere Auswahlmöglichkeiten",
            "301": "Permanent verschoben",
            "302": "Gefunden",
            "303": "Siehe andere Seite",
            "304": "Nicht modifiziert",
            "305": "Proxy verwenden",
            "307": "Temporäre Weiterleitung",
            "308": "Permanente Weiterleitung",
            "400": "Ungültige Anfrage",
            "401": "Nicht autorisiert",
            "402": "Zahlung erforderlich",
            "403": "Verboten",
            "404": "Nicht gefunden",
            "405": "Methode nicht erlaubt",
            "406": "Nicht annehmbar",
            "407": "Proxy-Authentifizierung erforderlich",
            "408": "Zeitüberschreitung der Anfrage",
            "409": "Konflikt",
            "410": "Nicht mehr verfügbar",
            "411": "Länge erforderlich",
            "412": "Vorbedingung fehlgeschlagen",
            "413": "Nutzlast zu groß",
            "414": "URI zu lang",
            "415": "Nicht unterstützter Medientyp",
            "416": "Bereich nicht erfüllbar",
            "417": "Erwartung gescheitert",
            "418": "Ich bin eine Teekanne",
            "419": "Sitzung ist abgelaufen",
            "421": "Fehlgeleitete Anfrage",
            "422": "Unverarbeitbare Entität",
            "423": "Gesperrt",
            "424": "Fehlgeschlagene Abhängigkeit",
            "425": "Zu früh",
            "426": "Upgrade erforderlich",
            "428": "Voraussetzung erforderlich",
            "429": "Zu viele Anfragen",
            "431": "Anfrage-Header-Felder zu groß",
            "444": "Verbindung ohne Antwort geschlossen",
            "449": "Wiederhole mit",
            "451": "Aus rechtlichen Gründen nicht verfügbar",
            "499": "Client-Closed-Request",
            "500": "Interner Serverfehler",
            "501": "Nicht implementiert",
            "502": "Fehlerhaftes Gateway",
            "503": "Wartungsmodus",
            "504": "Gateway-Zeitüberschreitung",
            "505": "HTTP Version nicht unterstützt",
            "506": "Variante verhandelt auch",
            "507": "Nicht genügend Speicherplatz",
            "508": "Endlosschleife erkannt",
            "509": "Bandbreitenlimit überschritten",
            "510": "Nicht erweitert",
            "511": "Netzwerkauthentifizierung erforderlich",
            "520": "Unbekannter Fehler",
            "521": "Webserver ist ausgefallen",
            "522": "Verbindung abgelaufen",
            "523": "Quelle ist nicht erreichbar",
            "524": "Eine Zeitüberschreitung ist aufgetreten",
            "525": "SSL Handshake fehlgeschlagen",
            "526": "Ungültiges SSL-Zertifikat",
            "527": "Railgun-Fehler",
            "598": "Zeitüberschreitungsfehler beim Lesen des Netzwerks",
            "599": "Zeitüberschreitungsfehler bei Netzwerkverbindung",
            "unknownError": "Unbekannter Fehler"
        },
        "routes": {
            "frequently-asked-questions": "haeufig-gestellte-fragen",
            "blog": "blog",
            "projects": "projekte",
            "about-us": "ueber-uns",
            "general-terms": "agb",
            "products": "produkte",
            "privacy-policy": "datenschutz",
            "cookie-policy": "cookie-richtlinie",
            "contact": "kontakt",
            "search": "suche",
            "vacancies": "stellenangebote",
            "faq": "faq",
            "team": "team",
            "news": "neuigkeiten",
            "/projects": "projekte"
        },
        "passwords": {
            "reset": "Das Passwort wurde zurückgesetzt!",
            "sent": "E-Mail zum Zurücksetzen des Passworts wurde gesendet!",
            "throttled": "Bitte warten Sie, bevor Sie es erneut versuchen.",
            "token": "Der Passwort-Wiederherstellungsschlüssel ist ungültig oder abgelaufen.",
            "user": "Es konnte leider kein Nutzer mit dieser E-Mail-Adresse gefunden werden."
        },
        "pagination": {
            "next": "Weiter &raquo;",
            "previous": "&laquo; Zurück"
        }
    },
    "en": {
        "{Attribute} {lang}": "{Attribute} {lang}",
        "{Attribute} is invalid": "{Attribute} is invalid",
        "{count} characters": "{count} characters",
        "{model} {action}": "{model} {action}",
        "(and {count} more error)": "(and {count} more error)",
        "(and {count} more errors)": "(and {count} more errors)",
        "*Required fields": "*Required fields",
        "404 - Page not found": "404 - Page not found",
        "A piece": "A piece",
        "A Timeout Occurred": "A Timeout Occurred",
        "About us": "About us",
        "Accepted": "Accepted",
        "Account": "Account",
        "activated": "activated",
        "Activated": "activated",
        "Active": "Active",
        "Add a underline to all titles": "Add a underline to all titles",
        "Add comment": "Add comment",
        "Add message": "Add message",
        "Add page block": "Add page block",
        "Add to cart": "Add to cart",
        "All": "All",
        "All {models}": "All {models}",
        "All block content in the language you are editing is replaced by the content of the language you pick. This cannot be undone.": "All block content in the language you are editing is replaced by the content of the language you pick. This cannot be undone.",
        "All projects (Including filter and pagination)": "All projects (Including filter and pagination)",
        "All rights reserved.": "All rights reserved.",
        "All vacancies (Including filter and pagination)": "All vacancies (Including filter and pagination)",
        "Already Reported": "Already Reported",
        "Alt text": "Alt text",
        "Amount projects": "Amount projects",
        "Amount vacancies": "Amount vacancies",
        "Answer": "Answer",
        "Apply directly": "Apply directly",
        "Apply discount code": "Apply discount code",
        "Apply now": "Apply now",
        "Author": "Author",
        "Back": "Back",
        "Back and mark as done": "Back and mark as done",
        "Back and release": "Back and release",
        "Back to home": "Back to home",
        "Backup codes": "Backup codes",
        "Bad Gateway": "Bad Gateway",
        "Bad Request": "Bad Request",
        "Bandwidth Limit Exceeded": "Bandwidth Limit Exceeded",
        "Banner": "Banner",
        "Birthday *": "Birthday *",
        "Blog Settings": "Blog Settings",
        "Blogs": "Blogs",
        "Body color": "Body color",
        "Bold": "Bold",
        "Bullet point": "Bullet point",
        "Bullet points": "Bullet points",
        "Button corners": "Button corners",
        "Button label": "Button label",
        "Buttons": "Buttons",
        "Checkout page": "Checkout page",
        "Choose file": "Choose file",
        "City": "City",
        "Client": "Client",
        "Client Closed Request": "Client Closed Request",
        "Clients": "Clients",
        "Close conversation": "Close conversation",
        "closed": "closed",
        "code": "code",
        "Comment": "Comment",
        "Company name": "Company name",
        "Complete": "Complete",
        "Concept in only visible to logged in users, draft is not visible to anyone": "Concept in only visible to logged in users, draft is not visible to anyone",
        "Conflict": "Conflict",
        "Connection Closed Without Response": "Connection Closed Without Response",
        "Connection Timed Out": "Connection Timed Out",
        "Consultant": "Consultant",
        "Contact": "Contact",
        "Contactform": "Contactform",
        "Content": "Content",
        "Content copied": "Content copied",
        "Continue": "Continue",
        "Conversation": "Conversation",
        "Conversations": "Conversations",
        "Copy and overwrite": "Copy and overwrite",
        "Copy content from another language": "Copy content from another language",
        "Copy content to {locale}": "Copy content to {locale}",
        "Copy from": "Copy from",
        "Copy from {locale}": "Copy from {locale}",
        "Copy the image from {locale}": "Copy the image from {locale}",
        "Copy this block from {locale}": "Copy this block from {locale}",
        "Create {model}": "Create {model}",
        "Create follow-up": "Create follow-up",
        "Create order": "Create order",
        "created": "created",
        "Created": "Created",
        "Created at": "Created at",
        "Dangerously high": "Dangerously high",
        "Dangerously high explanation": "Dangerously high explanation",
        "Dangerously Low": "Dangerously Low",
        "Dangerously low explanation": "Dangerously low explanation",
        "Date": "Date",
        "Date of birth": "Date of birth",
        "Deactivate": "Deactivate",
        "deactivated": "deactivated",
        "Deactivated": "deactivated",
        "Default consultant": "Default consultant",
        "Delete filters": "Delete filters",
        "deleted": "deleted",
        "description": "description",
        "Description": "Description",
        "Details": "Details",
        "Discount": "Discount",
        "Discount active": "Discount active",
        "Discount code": "Discount code",
        "done": "done",
        "Down": "Down",
        "Download app": "Download app",
        "Download backup codes and continue.": "Download backup codes and continue.",
        "Due at": "Due at",
        "E-mail": "E-mail",
        "E-mail *": "E-mail *",
        "Edit {model}": "Edit {model}",
        "Edit account": "Edit account",
        "email": "email",
        "Email": "Email",
        "End": "End",
        "Enter working hours here": "Enter working hours here",
        "excerpt": "excerpt",
        "Excerpt": "Excerpt",
        "Expectation Failed": "Expectation Failed",
        "External Test": "External Test",
        "External Tester": "External Tester",
        "External URL": "External URL",
        "Failed Dependency": "Failed Dependency",
        "Fill in the 6-digit code": "Fill in the 6-digit code",
        "First name": "First name",
        "First name *": "First name *",
        "Follow up to": "Follow up to",
        "Follow up tot": "Follow up tot",
        "Font": "Font",
        "Font size": "Font size",
        "Font weight": "Font weight",
        "Footer color": "Footer color",
        "Forbidden": "Forbidden",
        "Found": "Found",
        "From the authenticator app": "From the authenticator app",
        "Fully rounded": "Fully rounded",
        "Gallery": "Gallery",
        "Gateway Timeout": "Gateway Timeout",
        "Global": "Global",
        "Go to page {page}": "Go to page {page}",
        "Gone": "Gone",
        "Google Authenticator": "Google Authenticator",
        "Google maps URL": "Google maps URL",
        "Google Maps URL": "Google Maps URL",
        "Heading": "Heading",
        "Heading 1 is the main title and will be used on every page once": "Heading 1 is the main title and will be used on every page once",
        "Heading 2 are the subtitles and can be used multiple times on a page": "Heading 2 are the subtitles and can be used multiple times on a page",
        "Hello": "Hello",
        "Hello!": "Hello!",
        "Here you can turn on extra modules that are not included in the standard basic MediaMix template. Those are paid modules.": "Here you can turn on extra modules that are not included in the standard basic MediaMix template. Those are paid modules.",
        "High": "High",
        "High explanation": "High explanation",
        "Hits": "Hits",
        "Hours": "Hours",
        "HTTP Version Not Supported": "HTTP Version Not Supported",
        "I agree with the": "I agree with the",
        "I agree with the terms and conditions*": "I agree with the terms and conditions*",
        "I have saved the backup codes": "I have saved the backup codes",
        "I'm a teapot": "I'm a teapot",
        "Icon": "Icon",
        "If enabled, and no image is uploaded, the banner from the homepage will be shown.": "If enabled, and no image is uploaded, the banner from the homepage will be shown.",
        "If you did not create an account, no further action is required.": "If you did not create an account, no further action is required.",
        "If you did not request a password reset, no further action is required.": "If you did not request a password reset, no further action is required.",
        "If you're having trouble clicking the \"{actionText}\" button, copy and paste the URL belowninto your web browser:": "If you're having trouble clicking the \"{actionText}\" button, copy and paste the URL belowninto your web browser:",
        "IM Used": "IM Used",
        "Image": "Image",
        "Including VAT": "Including VAT",
        "Index Page": "Index Page",
        "Inloggen": "Inloggen",
        "Inspection": "Inspection",
        "Instruction title": "Instruction title",
        "Insufficient Storage": "Insufficient Storage",
        "Internal comment": "Internal comment",
        "Internal comments": "Internal comments",
        "Internal Server Error": "Internal Server Error",
        "Introduction": "Introduction",
        "Invalid phone number": "Invalid phone number",
        "Invalid SSL Certificate": "Invalid SSL Certificate",
        "It is recommended to keep the {attribute} between {min} and {max} characters long": "It is recommended to keep the {attribute} between {min} and {max} characters long",
        "Job position": "Job position",
        "Label Button": "Label Button",
        "Language": "Language",
        "Last message on": "Last message on",
        "Last name": "Last name",
        "Last name *": "Last name *",
        "Last refresh was {quantity} {unit} ago": "Last refresh was {quantity} {unit} ago",
        "Leave empty for no end date": "Leave empty for no end date",
        "Leave empty to use parent details": "Leave empty to use parent details",
        "Length Required": "Length Required",
        "Light": "Light",
        "Line height": "Line height",
        "Link Button": "Link Button",
        "Locked": "Locked",
        "Login": "Login",
        "Logoslider": "Logoslider",
        "Logout": "Logout",
        "Loop Detected": "Loop Detected",
        "Low": "Low",
        "Low explanation": "Low explanation",
        "Made by:": "Made by:",
        "Maintenance Mode": "Maintenance Mode",
        "Mark as done": "Mark as done",
        "Medical": "Medical",
        "Message": "Message",
        "Message *": "Message *",
        "Messages": "Messages",
        "Method Not Allowed": "Method Not Allowed",
        "Metric Name": "Metric Name",
        "Microsoft Authenticator": "Microsoft Authenticator",
        "minus icon": "minus icon",
        "Misdirected Request": "Misdirected Request",
        "Modules": "Modules",
        "More settings can be set in the Page Block Settings page": "More settings can be set in the Page Block Settings page",
        "Moved Permanently": "Moved Permanently",
        "Multi-Status": "Multi-Status",
        "Multiple Choices": "Multiple Choices",
        "Mute client": "Mute client",
        "muted": "muted",
        "Muted": "Muted",
        "name": "name",
        "Name": "Name",
        "Name *": "Name *",
        "Name client": "Name client",
        "Network Authentication Required": "Network Authentication Required",
        "Network Connect Timeout Error": "Network Connect Timeout Error",
        "Network Read Timeout Error": "Network Read Timeout Error",
        "New URL": "New URL",
        "Newsletter": "Newsletter",
        "No": "No",
        "No Content": "No Content",
        "No items": "No items",
        "Non-Authoritative Information": "Non-Authoritative Information",
        "None": "None",
        "Normal": "Normal",
        "Not Acceptable": "Not Acceptable",
        "Not Extended": "Not Extended",
        "Not Found": "Not Found",
        "Not Implemented": "Not Implemented",
        "Not implemented yet": "Not implemented yet",
        "Not Modified": "Not Modified",
        "of": "of",
        "OK": "OK",
        "Old URL": "Old URL",
        "On your phone or tablet with camera. We can advise you to use {google} or {microsoft}.": "On your phone or tablet with camera. We can advise you to use {google} or {microsoft}.",
        "Open the authenticator app, add a new entry and scan the QR code": "Open the authenticator app, add a new entry and scan the QR code",
        "Opening hours": "Opening hours",
        "Openings hours": "Openings hours",
        "Order": "Order",
        "Origin Is Unreachable": "Origin Is Unreachable",
        "Overview": "Overview",
        "Package name": "Package name",
        "Packages": "Packages",
        "Page (within website)": "Page (within website)",
        "Page blocks": "Page blocks",
        "Page Expired": "Page Expired",
        "Page Title": "Page Title",
        "PageHeader": "PageHeader",
        "Pagination Navigation": "Pagination Navigation",
        "Paragraph": "Paragraph",
        "Parent category": "Parent category",
        "Partial Content": "Partial Content",
        "Password": "Password",
        "Paste in here only the Youtube ID. That id the ID what you see in the url in the browser after https://www.youtube.com/watch?v=": "Paste in here only the Youtube ID. That id the ID what you see in the url in the browser after https://www.youtube.com/watch?v=",
        "Paste or type the code we sent a code to your e-mail.": "Paste or type the code we sent a code to your e-mail.",
        "Paste or type the code we sent a code to your phone number.": "Paste or type the code we sent a code to your phone number.",
        "Payload Too Large": "Payload Too Large",
        "Payment Required": "Payment Required",
        "Permanent": "Permanent",
        "Permanent Redirect": "Permanent Redirect",
        "Phone": "Phone",
        "Phone *": "Phone *",
        "phone number": "phone number",
        "Phone number": "Phone number",
        "phone_number": "phone_number",
        "Place": "Place",
        "Please click the button below to verify your email address.": "Please click the button below to verify your email address.",
        "plus icon": "plus icon",
        "Postal code": "Postal code",
        "Postcode": "Postcode",
        "Precondition Failed": "Precondition Failed",
        "Precondition Required": "Precondition Required",
        "Price": "Price",
        "Price frequency": "Price frequency",
        "Primary Color": "Primary Color",
        "Print": "Print",
        "Priority": "Priority",
        "Privacy declaration": "Privacy declaration",
        "Processing": "Processing",
        "Product": "Product",
        "Products": "Products",
        "Project Content": "Project Content",
        "Projects": "Projects",
        "Proxy Authentication Required": "Proxy Authentication Required",
        "Question": "Question",
        "Railgun Error": "Railgun Error",
        "Range Not Satisfiable": "Range Not Satisfiable",
        "Reactivate": "Reactivate",
        "Read more": "Read more",
        "Regards": "Regards",
        "Register": "Register",
        "Regular": "Regular",
        "Related products": "Related products",
        "Remove": "Remove",
        "Remove discount code": "Remove discount code",
        "Reopened subtask": "Reopened subtask",
        "Request Header Fields Too Large": "Request Header Fields Too Large",
        "Request Timeout": "Request Timeout",
        "Resend {attribute}": "Resend {attribute}",
        "Reserved By": "Reserved By",
        "Reset Content": "Reset Content",
        "Reset Password": "Reset Password",
        "Reset Password Notification": "Reset Password Notification",
        "results": "results",
        "Results": "results",
        "Results are shared": "Results are shared",
        "Retry With": "Retry With",
        "Review": "Review",
        "Review Slider": "Review Slider",
        "Reviews": "Reviews",
        "Reviewslider": "Reviewslider",
        "role": "role",
        "Role": "Role",
        "Roles": "Roles",
        "Rounded": "Rounded",
        "Sampled at": "Sampled at",
        "Save": "Save",
        "Save these codes on a secure place if you can’t get access with your Authenticator app.": "Save these codes on a secure place if you can’t get access with your Authenticator app.",
        "Scan the QR code": "Scan the QR code",
        "Scanning not possible? Fill in this code in the app.": "Scanning not possible? Fill in this code in the app.",
        "Search": "Search",
        "Secondary Color": "Secondary Color",
        "See all faqs": "See all faqs",
        "See Other": "See Other",
        "Select a {model}": "Select a {model}",
        "Select a template to add the corresponding blocks.": "Select a template to add the corresponding blocks.",
        "Select a template to add the corresponding blocks. Note that this cannot be changed after page has been created": "Select a template to add the corresponding blocks. Note that this cannot be changed after page has been created",
        "Select a test": "Select a test",
        "Select a type": "Select a type",
        "Send application": "Send application",
        "SEO title": "SEO title",
        "Server Error": "Server Error",
        "Service Unavailable": "Service Unavailable",
        "Session Has Expired": "Session Has Expired",
        "Set all titles to uppercase": "Set all titles to uppercase",
        "Set color for the footer.": "Set color for the footer.",
        "Set Two Factor Authentication": "Set Two Factor Authentication",
        "Sets": "Sets",
        "Share results": "Share results",
        "shared": "shared",
        "Shipping address same as billing address": "Shipping address same as billing address",
        "Shipping method": "Shipping method",
        "Shop": "Shop",
        "Shop not finished yet...": "Shop not finished yet...",
        "Showing": "Showing",
        "Sign out": "Sign out",
        "Slug": "Slug",
        "Social media": "Social media",
        "SSL Handshake Failed": "SSL Handshake Failed",
        "Stars": "Stars",
        "Start": "Start",
        "Start date:": "Start date:",
        "Started at": "Started at",
        "Status": "Status",
        "Statuses": "Statuses",
        "Street name": "Street name",
        "Street number": "Street number",
        "Street number addition": "Street number addition",
        "Subject *": "Subject *",
        "Submit": "Submit",
        "SubTasks": "SubTasks",
        "Subtotal": "Subtotal",
        "Switching Protocols": "Switching Protocols",
        "Task": "Task",
        "Tasks": "Tasks",
        "Temporary Redirect": "Temporary Redirect",
        "terms and conditions": "terms and conditions",
        "Terms and Conditions": "Terms and Conditions",
        "Tertiary Color": "Tertiary Color",
        "test": "test",
        "Test": "Test",
        "test set": "test set",
        "Test set": "Test set",
        "Test sets": "Test sets",
        "Tests": "Tests",
        "Text": "Text",
        "Text transform": "Text transform",
        "Thank you for your application!": "Thank you for your application!",
        "Thank you for your message!": "Thank you for your message!",
        "Thank you for your sign up!": "Thank you for your sign up!",
        "The {attribute} has already been taken.": "The {attribute} has already been taken.",
        "The {attribute} must be verified.": "The {attribute} must be verified.",
        "The {attribute} must contain at least one letter.": "The {attribute} must contain at least one letter.",
        "The {attribute} must contain at least one number.": "The {attribute} must contain at least one number.",
        "The {attribute} must contain at least one symbol.": "The {attribute} must contain at least one symbol.",
        "The {attribute} must contain at least one uppercase and one lowercase letter.": "The {attribute} must contain at least one uppercase and one lowercase letter.",
        "The content of this block in the language you are editing is replaced. The other languages are left alone.": "The content of this block in the language you are editing is replaced. The other languages are left alone.",
        "The coupon has already been used.": "The coupon has already been used.",
        "The coupon has expired.": "The coupon has expired.",
        "The font size for the main / body font.": "The font size for the main / body font.",
        "The given {attribute} has appeared in a data leak. Please choose a different {attribute}.": "The given {attribute} has appeared in a data leak. Please choose a different {attribute}.",
        "The given data was invalid.": "The given data was invalid.",
        "The image of the language you are editing is replaced. The other languages are left alone.": "The image of the language you are editing is replaced. The other languages are left alone.",
        "The provided {attribute} is invalid.": "The provided {attribute} is invalid.",
        "The provided code was invalid.": "The provided code was invalid.",
        "The provided password does not match your current password.": "The provided password does not match your current password.",
        "The provided two factor authentication code was invalid.": "The provided two factor authentication code was invalid.",
        "The styling for all mails like contactform, newsletter etc.": "The styling for all mails like contactform, newsletter etc.",
        "The tests cannot be changed once the test set is created.": "The tests cannot be changed once the test set is created.",
        "The thickness of the font that will be displayed": "The thickness of the font that will be displayed",
        "The thickness of the font that will be displayed for all heading titles": "The thickness of the font that will be displayed for all heading titles",
        "This {attribute} has already been used": "This {attribute} has already been used",
        "This area is restricted to medical medic members only.": "This area is restricted to medical medic members only.",
        "This area is restricted to staff members only.": "This area is restricted to staff members only.",
        "This changes every language": "This changes every language",
        "This font will be used as main / body font.": "This font will be used as main / body font.",
        "This font will be used for all heading titles H1, H2, H3. H4, H5, H6": "This font will be used for all heading titles H1, H2, H3. H4, H5, H6",
        "This is your first login": "This is your first login",
        "This password reset link will expire in {count} minutes.": "This password reset link will expire in {count} minutes.",
        "This task is reserved by {userName}": "This task is reserved by {userName}",
        "This task is reserved by {userName}.": "This task is reserved by {userName}.",
        "title": "title",
        "Title": "Title",
        "to": "to",
        "To use Top Chefs Two Factor Authentication is required as extra security, you can set this now": "To use Top Chefs Two Factor Authentication is required as extra security, you can set this now",
        "TODO": "TODO",
        "Toggle navigation": "Toggle navigation",
        "token": "token",
        "Too Early": "Too Early",
        "Too Many Requests": "Too Many Requests",
        "Total": "Total",
        "Trans": "Trans",
        "Two Factor Authentication - Backup codes": "Two Factor Authentication - Backup codes",
        "Type": "Type",
        "Type job position": "Type job position",
        "Unauthorized": "Unauthorized",
        "Unavailable For Legal Reasons": "Unavailable For Legal Reasons",
        "Underline": "Underline",
        "Unknown Error": "Unknown Error",
        "Unmute client": "Unmute client",
        "unmuted": "unmuted",
        "Unprocessable Entity": "Unprocessable Entity",
        "Unsupported Media Type": "Unsupported Media Type",
        "Up": "Up",
        "updated": "updated",
        "Upgrade Required": "Upgrade Required",
        "Upload C.V *": "Upload C.V *",
        "Upload cover letter *": "Upload cover letter *",
        "Upload CV *": "Upload CV *",
        "Upload Motivation *": "Upload Motivation *",
        "Uppercase": "Uppercase",
        "URI Too Long": "URI Too Long",
        "url": "url",
        "Use Proxy": "Use Proxy",
        "user": "user",
        "User": "User",
        "Users": "Users",
        "USPs": "USPs",
        "Uw winkelmand is leeg": "Uw winkelmand is leeg",
        "Vacancies": "Vacancies",
        "Vacancy Content": "Vacancy Content",
        "Vacancyfilters": "Vacancyfilters",
        "Variant Also Negotiates": "Variant Also Negotiates",
        "Variants": "Variants",
        "VAT": "VAT",
        "Verify": "Verify",
        "Verify {attribute}": "Verify {attribute}",
        "Verify Email Address": "Verify Email Address",
        "Videos": "Videos",
        "View project": "View project",
        "View vacancy": "View vacancy",
        "We have done our best, but it seems that the page you requested does not exist (anymore) or that it may have moved.": "We have done our best, but it seems that the page you requested does not exist (anymore) or that it may have moved.",
        "We have received your message. One of our employees will contact you as soon as possible.": "We have received your message. One of our employees will contact you as soon as possible.",
        "Web Page": "Web Page",
        "Web Page Settings": "Web Page Settings",
        "Web Server is Down": "Web Server is Down",
        "weekly": "weekly",
        "Welcome": "Welcome",
        "Welcome to {page}": "Welcome to {page}",
        "When enabled, an email will be sent to the user, letting them know their account has been created.": "When enabled, an email will be sent to the user, letting them know their account has been created.",
        "Which blocks a page has is shared between languages, so adding or removing one here does the same in the other languages. Only the content inside a block belongs to the language you are editing.": "Which blocks a page has is shared between languages, so adding or removing one here does the same in the other languages. Only the content inside a block belongs to the language you are editing.",
        "Whoops!": "Whoops!",
        "Will be used as main color for buttons, links, elements or components with a background color": "Will be used as main color for buttons, links, elements or components with a background color",
        "Will be used as main color for the body text": "Will be used as main color for the body text",
        "Yes": "Yes",
        "You are receiving this email because we received a password reset request for your account.": "You are receiving this email because we received a password reset request for your account.",
        "Your account for {siteName}": "Your account for {siteName}",
        "Your account is inactive. Please contact support.": "Your account is inactive. Please contact support.",
        "Your account is inactive. Please contact support. To use the website as a guest, please refresh the page.": "Your account is inactive. Please contact support. To use the website as a guest, please refresh the page.",
        "Your current locale is {locale}": "Your current locale is {locale}",
        "Your last login was {relativeTime} on {dateTime}": "Your last login was {relativeTime} on {dateTime}",
        "Your order": "Your order",
        "Your Order": "Your Order",
        "Your Profile": "Your Profile",
        "Youtube": "Youtube",
        "Youtube Video ID": "Youtube Video ID",
        "auth": {
            "failed": "These credentials do not match our records.",
            "password": "The password is incorrect.",
            "throttle": "Too many login attempts. Please try again in {seconds} seconds."
        },
        "validation": {
            "accepted": "The {attribute} must be accepted.",
            "accepted_if": "The {attribute} must be accepted when {other} is {value}.",
            "active_url": "The {attribute} is not a valid URL.",
            "after": "The {attribute} must be a date after {date}.",
            "after_or_equal": "The {attribute} must be a date after or equal to {date}.",
            "alpha": "The {attribute} may only contain letters.",
            "alpha_dash": "The {attribute} may only contain letters, numbers, and dashes.",
            "alpha_num": "The {attribute} may only contain letters and numbers.",
            "array": "The {attribute} must be an array.",
            "ascii": "The {attribute} must only contain single-byte alphanumeric characters and symbols.",
            "before": "The {attribute} must be a date before {date}.",
            "before_or_equal": "The {attribute} must be a date before or equal to {date}.",
            "between": {
                "array": "The {attribute} must have between {min} and {max} items.",
                "file": "The {attribute} must be between {min} and {max} kilobytes.",
                "numeric": "The {attribute} must be between {min} and {max}.",
                "string": "The {attribute} must be between {min} and {max} characters."
            },
            "boolean": "The {attribute} field must be true or false.",
            "confirmed": "The {attribute} confirmation does not match.",
            "current_password": "The password is incorrect.",
            "date": "The {attribute} is not a valid date.",
            "date_equals": "The {attribute} must be a date equal to {date}.",
            "date_format": "The {attribute} does not match the format {format}.",
            "decimal": "The {attribute} must have {decimal} decimal places.",
            "declined": "The {attribute} must be declined.",
            "declined_if": "The {attribute} must be declined when {other} is {value}.",
            "different": "The {attribute} and {other} must be different.",
            "digits": "The {attribute} must be {digits} digits.",
            "digits_between": "The {attribute} must be between {min} and {max} digits.",
            "dimensions": "The {attribute} has invalid image dimensions.",
            "distinct": "The {attribute} field has a duplicate value.",
            "doesnt_end_with": "The {attribute} may not end with one of the following: {values}.",
            "doesnt_start_with": "The {attribute} may not start with one of the following: {values}.",
            "email": "The {attribute} must be a valid email address.",
            "ends_with": "The {attribute} must end with one of the following: {values}.",
            "enum": "The selected {attribute} is invalid.",
            "exists": "The selected {attribute} is invalid.",
            "file": "The {attribute} must be a file.",
            "filled": "The {attribute} field is required.",
            "gt": {
                "array": "The {attribute} must have more than {value} items.",
                "file": "The {attribute} must be greater than {value} kilobytes.",
                "numeric": "The {attribute} must be greater than {value}.",
                "string": "The {attribute} must be greater than {value} characters."
            },
            "gte": {
                "array": "The {attribute} must have {value} items or more.",
                "file": "The {attribute} must be greater than or equal {value} kilobytes.",
                "numeric": "The {attribute} must be greater than or equal {value}.",
                "string": "The {attribute} must be greater than or equal {value} characters."
            },
            "image": "The {attribute} must be an image.",
            "in": "The selected {attribute} is invalid.",
            "in_array": "The {attribute} field does not exist in {other}.",
            "integer": "The {attribute} must be an integer.",
            "ip": "The {attribute} must be a valid IP address.",
            "ipv4": "The {attribute} must be a valid IPv4 address.",
            "ipv6": "The {attribute} must be a valid IPv6 address.",
            "json": "The {attribute} must be a valid JSON string.",
            "lowercase": "The {attribute} must be lowercase.",
            "lt": {
                "array": "The {attribute} must have less than {value} items.",
                "file": "The {attribute} must be less than {value} kilobytes.",
                "numeric": "The {attribute} must be less than {value}.",
                "string": "The {attribute} must be less than {value} characters."
            },
            "lte": {
                "array": "The {attribute} must not have more than {value} items.",
                "file": "The {attribute} must be less than or equal {value} kilobytes.",
                "numeric": "The {attribute} must be less than or equal {value}.",
                "string": "The {attribute} must be less than or equal {value} characters."
            },
            "mac_address": "The {attribute} must be a valid MAC address.",
            "max": {
                "array": "The {attribute} may not have more than {max} items.",
                "file": "The {attribute} may not be greater than {max} kilobytes.",
                "numeric": "The {attribute} may not be greater than {max}.",
                "string": "The {attribute} may not be greater than {max} characters."
            },
            "max_digits": "The {attribute} must not have more than {max} digits.",
            "mimes": "The {attribute} must be a file of type: {values}.",
            "mimetypes": "The {attribute} must be a file of type: {values}.",
            "min": {
                "array": "The {attribute} must have at least {min} items.",
                "file": "The {attribute} must be at least {min} kilobytes.",
                "numeric": "The {attribute} must be at least {min}.",
                "string": "The {attribute} must be at least {min} characters."
            },
            "min_digits": "The {attribute} must have at least {min} digits.",
            "missing": "The {attribute} field must be missing.",
            "missing_if": "The {attribute} field must be missing when {other} is {value}.",
            "missing_unless": "The {attribute} field must be missing unless {other} is {value}.",
            "missing_with": "The {attribute} field must be missing when {values} is present.",
            "missing_with_all": "The {attribute} field must be missing when {values} are present.",
            "multiple_of": "The {attribute} must be a multiple of {value}.",
            "not_in": "The selected {attribute} is invalid.",
            "not_regex": "The {attribute} format is invalid.",
            "numeric": "The {attribute} must be a number.",
            "password": {
                "letters": "The {attribute} must contain at least one letter.",
                "mixed": "The {attribute} must contain at least one uppercase and one lowercase letter.",
                "numbers": "The {attribute} must contain at least one number.",
                "symbols": "The {attribute} must contain at least one symbol.",
                "uncompromised": "The given {attribute} has appeared in a data leak. Please choose a different {attribute}."
            },
            "present": "The {attribute} field must be present.",
            "prohibited": "The {attribute} field is prohibited.",
            "prohibited_if": "The {attribute} field is prohibited when {other} is {value}.",
            "prohibited_unless": "The {attribute} field is prohibited unless {other} is in {values}.",
            "prohibits": "The {attribute} field prohibits {other} from being present.",
            "regex": "The {attribute} format is invalid.",
            "required": "The {attribute} field is required.",
            "required_array_keys": "The {attribute} field must contain entries for: {values}.",
            "required_if": "The {attribute} field is required when {other} is {value}.",
            "required_if_accepted": "The {attribute} field is required when {other} is accepted.",
            "required_unless": "The {attribute} field is required unless {other} is in {values}.",
            "required_with": "The {attribute} field is required when {values} is present.",
            "required_with_all": "The {attribute} field is required when {values} is present.",
            "required_without": "The {attribute} field is required when {values} is not present.",
            "required_without_all": "The {attribute} field is required when none of {values} are present.",
            "same": "The {attribute} and {other} must match.",
            "size": {
                "array": "The {attribute} must contain {size} items.",
                "file": "The {attribute} must be {size} kilobytes.",
                "numeric": "The {attribute} must be {size}.",
                "string": "The {attribute} must be {size} characters."
            },
            "starts_with": "The {attribute} must start with one of the following: {values}",
            "string": "The {attribute} must be a string.",
            "timezone": "The {attribute} must be a valid zone.",
            "ulid": "The {attribute} must be a valid ULID.",
            "unique": "The {attribute} has already been taken.",
            "uploaded": "The {attribute} failed to upload.",
            "uppercase": "The {attribute} must be uppercase.",
            "url": "The {attribute} format is invalid.",
            "uuid": "The {attribute} must be a valid UUID.",
            "attributes": {
                "address": "address",
                "affiliate_url": "affiliate URL",
                "age": "age",
                "amount": "amount",
                "announcement": "announcement",
                "area": "area",
                "audience_prize": "audience prize",
                "audience_winner": "audience winner",
                "available": "available",
                "billing_address.city": "city",
                "billing_address.country": "country",
                "billing_address.postcode": "postcode",
                "billing_address.street_name": "street name",
                "billing_address.street_number": "street number",
                "billing_address.street_number_addition": "street number addition",
                "birthday": "birthday",
                "body": "body",
                "city": "city",
                "company": "company",
                "compilation": "compilation",
                "concept": "concept",
                "conditions": "conditions",
                "consultant_id": "consultant",
                "content": "content",
                "contest": "contest",
                "country": "country",
                "cover": "cover",
                "created_at": "created at",
                "creator": "creator",
                "currency": "currency",
                "current_password": "current password",
                "customer": "customer",
                "date": "date",
                "date_of_birth": "date of birth",
                "dates": "dates",
                "day": "day",
                "deleted_at": "deleted at",
                "description": "description",
                "display_type": "display type",
                "district": "district",
                "duration": "duration",
                "email": "email",
                "excerpt": "excerpt",
                "filter": "filter",
                "finished_at": "finished at",
                "first_name": "first name",
                "gender": "gender",
                "grand_prize": "grand prize",
                "group": "group",
                "hour": "hour",
                "image": "image",
                "image_desktop": "desktop image",
                "image_main": "main image",
                "image_mobile": "mobile image",
                "images": "images",
                "is_audience_winner": "is audience winner",
                "is_hidden": "is hidden",
                "is_subscribed": "is subscribed",
                "is_visible": "is visible",
                "is_winner": "is winner",
                "items": "items",
                "key": "key",
                "last_name": "last name",
                "lesson": "lesson",
                "line_address_1": "line address 1",
                "line_address_2": "line address 2",
                "login": "login",
                "message": "message",
                "middle_name": "middle name",
                "minute": "minute",
                "mobile": "mobile",
                "month": "month",
                "name": "name",
                "national_code": "national code",
                "number": "number",
                "password": "password",
                "password_confirmation": "password confirmation",
                "phone": "phone",
                "photo": "photo",
                "portfolio": "portfolio",
                "postal_code": "postal code",
                "preview": "preview",
                "price": "price",
                "product_id": "product ID",
                "product_uid": "product UID",
                "product_uuid": "product UUID",
                "promo_code": "promo code",
                "province": "province",
                "quantity": "quantity",
                "reason": "reason",
                "recaptcha_response_field": "recaptcha response field",
                "referee": "referee",
                "referees": "referees",
                "reject_reason": "reject reason",
                "remember": "remember",
                "restored_at": "restored at",
                "result_text_under_image": "result text under image",
                "role": "role",
                "role_id": "role",
                "rule": "rule",
                "rules": "rules",
                "second": "second",
                "sex": "sex",
                "shipment": "shipment",
                "shipping_address.city": "city",
                "shipping_address.country": "country",
                "shipping_address.postcode": "postcode",
                "shipping_address.street_name": "street name",
                "shipping_address.street_number": "street number",
                "shipping_address.street_number_addition": "street number addition",
                "shipping_rate_id": "shipping rate",
                "short_text": "short text",
                "size": "size",
                "skills": "skills",
                "slug": "slug",
                "specialization": "specialization",
                "started_at": "started at",
                "state": "state",
                "status": "status",
                "street": "street",
                "student": "student",
                "subject": "subject",
                "tag": "tag",
                "tags": "tags",
                "teacher": "teacher",
                "terms": "terms",
                "test_description": "test description",
                "test_locale": "test locale",
                "test_name": "test name",
                "text": "text",
                "time": "time",
                "title": "title",
                "type": "type",
                "updated_at": "updated at",
                "user": "user",
                "username": "username",
                "value": "value",
                "winner": "winner",
                "work": "work",
                "year": "year",
                "cv": "CV",
                "locale": "locale",
                "motivation": "motivation",
                "order": "order",
                "place": "place",
                "url": "URL",
                "vacancy_id": "vacancy"
            }
        },
        "http-statuses": {
            "0": "Unknown Error",
            "100": "Continue",
            "101": "Switching Protocols",
            "102": "Processing",
            "200": "OK",
            "201": "Created",
            "202": "Accepted",
            "203": "Non-Authoritative Information",
            "204": "No Content",
            "205": "Reset Content",
            "206": "Partial Content",
            "207": "Multi-Status",
            "208": "Already Reported",
            "226": "IM Used",
            "300": "Multiple Choices",
            "301": "Moved Permanently",
            "302": "Found",
            "303": "See Other",
            "304": "Not Modified",
            "305": "Use Proxy",
            "307": "Temporary Redirect",
            "308": "Permanent Redirect",
            "400": "Bad Request",
            "401": "Unauthorized",
            "402": "Payment Required",
            "403": "Forbidden",
            "404": "Not Found",
            "405": "Method Not Allowed",
            "406": "Not Acceptable",
            "407": "Proxy Authentication Required",
            "408": "Request Timeout",
            "409": "Conflict",
            "410": "Gone",
            "411": "Length Required",
            "412": "Precondition Failed",
            "413": "Payload Too Large",
            "414": "URI Too Long",
            "415": "Unsupported Media Type",
            "416": "Range Not Satisfiable",
            "417": "Expectation Failed",
            "418": "I'm a teapot",
            "419": "Session Has Expired",
            "421": "Misdirected Request",
            "422": "Unprocessable Entity",
            "423": "Locked",
            "424": "Failed Dependency",
            "425": "Too Early",
            "426": "Upgrade Required",
            "428": "Precondition Required",
            "429": "Too Many Requests",
            "431": "Request Header Fields Too Large",
            "444": "Connection Closed Without Response",
            "449": "Retry With",
            "451": "Unavailable For Legal Reasons",
            "499": "Client Closed Request",
            "500": "Internal Server Error",
            "501": "Not Implemented",
            "502": "Bad Gateway",
            "503": "Maintenance Mode",
            "504": "Gateway Timeout",
            "505": "HTTP Version Not Supported",
            "506": "Variant Also Negotiates",
            "507": "Insufficient Storage",
            "508": "Loop Detected",
            "509": "Bandwidth Limit Exceeded",
            "510": "Not Extended",
            "511": "Network Authentication Required",
            "520": "Unknown Error",
            "521": "Web Server is Down",
            "522": "Connection Timed Out",
            "523": "Origin Is Unreachable",
            "524": "A Timeout Occurred",
            "525": "SSL Handshake Failed",
            "526": "Invalid SSL Certificate",
            "527": "Railgun Error",
            "598": "Network Read Timeout Error",
            "599": "Network Connect Timeout Error",
            "unknownError": "Unknown Error"
        },
        "routes": {
            "frequently-asked-questions": "frequently-asked-questions",
            "blog": "blog",
            "projects": "projects",
            "about-us": "about-us",
            "general-terms": "general-terms",
            "privacy-policy": "privacy-policy",
            "cookie-policy": "cookie-policy",
            "contact": "contact",
            "products": "products",
            "search": "search",
            "vacancies": "vacancies",
            "faq": "faq",
            "team": "team",
            "news": "news",
            "/projects": "projects"
        },
        "passwords": {
            "reset": "Your password has been reset!",
            "sent": "We have emailed your password reset link!",
            "throttled": "Please wait before retrying.",
            "token": "This password reset token is invalid.",
            "user": "We have emailed your password reset link!"
        },
        "pagination": {
            "next": "Next &raquo;",
            "previous": "&laquo; Previous"
        }
    },
    "nl": {
        "{Attribute} {lang}": "{Attribute} {lang}",
        "{Attribute} is invalid": "{Attribute} is ongeldig",
        "{count} characters": "{count} characters",
        "{model} {action}": "{model} {action}",
        "(and {count} more error)": "(en {count} andere foutmelding)",
        "(and {count} more errors)": "(en {count} andere foutmeldingen)",
        "*Required fields": "*Verplichte velden",
        "1 star": "1 ster",
        "2 stars": "2 sterren",
        "3 stars": "3 sterren",
        "4 stars": "4 sterren",
        "404 - Page not found": "404 - Pagina niet gevonden",
        "5 stars": "5 sterren",
        "8-12 hours": "8-12 uur",
        "A piece": "Per stuk",
        "A Timeout Occurred": "Time-out opgetreden",
        "About HGBI": "Over HGBI",
        "About the cookies on this website": "Over de cookies op deze website",
        "About us": "Over ons",
        "Accepted": "Aanvaard",
        "Account": "Account",
        "activated": "geactiveerd",
        "Activated": "Geactiveerd",
        "Active": "Actief",
        "Add a underline to all titles": "Maak alle titels onderstreept",
        "Add menu item": "Menu-item toevoegen",
        "Add message": "Bericht toevoegen",
        "Add page block": "Pagina blok toevoegen",
        "Add phone number in global template options": "Telefoonnummer toevoegen in globale sjabloonopties",
        "All": "Alles",
        "All {models}": "Alle {models}",
        "All block content in the language you are editing is replaced by the content of the language you pick. This cannot be undone.": "Alle blokinhoud in de taal die je bewerkt wordt vervangen door de inhoud van de taal die je kiest. Dit kan niet ongedaan worden gemaakt.",
        "All news (Including filter and pagination)": "Alle nieuws (inclusief filter en paginering)",
        "All projects (Including filter and pagination)": "Alle projecten (Inclusief filters en paginatie)",
        "All rights reserved.": "Alle rechten voorbehouden.",
        "All team members (Including pagination)": "Alle teamleden (inclusief paginering)",
        "All vacancies (Including filter and pagination)": "Alle vacatures (Inclusief filters en paginatie)",
        "Already Reported": "Al gemeld",
        "Alt text": "Alt-tekst",
        "Amount Blogs": "Bedrag Blogs",
        "Amount news": "Bedrag nieuws",
        "Amount projects": "Hoeveelheid projecten",
        "Amount team members": "Bedrag teamleden",
        "Amount vacancies": "Hoeveelheid vacatures",
        "Answer": "Antwoord",
        "any": "enkele",
        "Apply directly": "Solliciteer nu",
        "Apply discount code": "Kortingscode toepassen",
        "Apply now": "Solliciteer nu",
        "Author": "Auteur",
        "Author:": "Auteur:",
        "Back": "Terug",
        "Back and mark as done": "Terug en markeer als klaar",
        "Back and release": "Terug en loslaten",
        "Back to home": "Terug naar home",
        "Background color": "Achtergrondkleur",
        "Background image": "Achtergrondafbeelding",
        "Backup codes": "Back-up codes",
        "Bad Gateway": "Slechte poort",
        "Bad Request": "Foute aanvraag",
        "Bandwidth Limit Exceeded": "Bandbreedte overschreden",
        "Banner": "Banner",
        "Banner (Slider Variant)": "Banner (schuifvariant)",
        "Birthday *": "Geboortedatum *",
        "Black": "Zwart",
        "Blog": "Blog",
        "Blog Content": "Blog inhoud",
        "Blog Settings": "Blog Instellingen",
        "Blogs": "Blogs",
        "Blogs (Including filter and pagination)": "Blogs (inclusief filter en paginering)",
        "Body color": "Tekst kleur",
        "Bold": "Dikgedrukt",
        "Bullet point": "Bullet point",
        "Bullet points": "Bullet points",
        "Button corners": "Knop hoeken",
        "Button label": "Knoplabel",
        "Button only shows up if module is set to active": "Knop verschijnt alleen als module is ingesteld op actief",
        "Buttons": "Knoppen",
        "Checkout page": "Afrekenpagina",
        "Choose file": "Kies bestand",
        "City": "Stad",
        "Client": "Cliënt",
        "Client Closed Request": "Klant Gesloten Verzoek",
        "Clients": "Cliënten",
        "Close conversation": "sluit gesprek",
        "closed": "gesloten",
        "code": "code",
        "Comment": "Commentaar",
        "Company name": "Bedrijfsnaam",
        "Complete": "Compleet",
        "Concept in only visible to logged in users, draft is not visible to anyone": "Concept in alleen zichtbaar voor ingelogde gebruikers, draft is voor niemand zichtbaar",
        "Conflict": "Conflict",
        "Connection Closed Without Response": "Verbinding gesloten zonder reactie",
        "Connection Timed Out": "Connectie duurt te lang",
        "Consultant": "Consultant",
        "Contact": "Contact",
        "Contact form": "Contactformulier",
        "Contactform": "Contactformulier",
        "Content": "Inhoud",
        "Content copied": "Inhoud gekopieerd",
        "Continue": "Doorgaan",
        "Conversation": "Gesprek",
        "Conversations": "Gesprekken",
        "Copy and overwrite": "Kopiëren en overschrijven",
        "Copy content from another language": "Inhoud kopiëren uit een andere taal",
        "Copy content to {locale}": "Inhoud kopiëren naar {locale}",
        "Copy from": "Kopiëren uit",
        "Copy from {locale}": "Kopiëren uit {locale}",
        "Copy the image from {locale}": "De afbeelding kopiëren uit {locale}",
        "Copy this block from {locale}": "Dit blok kopiëren uit {locale}",
        "Counter": "Tegen",
        "Counter number": "Teller",
        "Counter Short description": "Teller Korte beschrijving",
        "Counter title": "Titel",
        "Counters": "Tellers",
        "create": "maak aan",
        "Create {model}": "Maak {model}",
        "Create a password": "Maak een wachtwoord aan",
        "Create follow-up": "Follow-up creëren",
        "Create order": "Bestel",
        "created": "aangemaakt",
        "Created": "Aangemaakt",
        "Created at": "Gemaakt op ",
        "Created At": "Gemaakt op",
        "Custom": "Aangepast",
        "Custom background color": "Aangepaste achtergrondkleur",
        "Custom text color": "Aangepaste tekstkleur",
        "Custom title": "Aangepaste titel",
        "Customers will be shown the cheapest applicable shipping rate from each group. Currently existing groups: {groups}": "Klanten krijgen de goedkoopste toepasselijke verzendkosten van elke groep te zien. Momenteel bestaande groepen: {groups}",
        "Dangerously high": "Gevaarlijk hoog",
        "Dangerously high explanation": "Gevaarlijk hoge uitleg",
        "Dangerously Low": "Gevaarlijk laag",
        "Dangerously low explanation": "Gevaarlijk lage verklaring",
        "Date": "Datum",
        "Date of birth": "Geboortedatum",
        "Deactivate": "Deactiveer",
        "deactivated": "gedeactiveerd",
        "Deactivated": "gedeactiveerd",
        "Dear": "Beste",
        "Default consultant": "Standaard consulent",
        "delete": "verwijder",
        "Delete": "Verwijder",
        "Delete filters": "Filters verwijderen",
        "deleted": "verwijderd",
        "description": "beschrijving",
        "Description": "Beschrijving",
        "Desktop": "Desktop",
        "Details": "Details",
        "Discount": "Korting",
        "Discount active": "Korting actief",
        "Discount code": "Kortingscode",
        "done": "klaar",
        "Down": "Down",
        "Download app": "App downloaden",
        "Download backup codes and continue.": "Download back-up codes en ga verder.",
        "Download PDF button name": "Knopnaam PDF downloaden",
        "Due at": "Toe doen op",
        "E-mail": "E-mail",
        "E-mail *": "E-mail *",
        "edit": "bewerk",
        "Edit": "Bewerk",
        "Edit {model}": "{model} bewerken",
        "Edit account": "Account bewerken",
        "email": "e-mail",
        "Email": "E-mail",
        "Employees": "Werknemers",
        "employers": "werkgevers",
        "Employers": "Werkgevers",
        "End": "Einde",
        "Enter working hours here": "Voer hier de werkuren in",
        "excerpt": "uittreksel",
        "Excerpt": "Uittreksel",
        "Expectation Failed": "Niet voldaan aan verwachting",
        "Export": "Exporteren",
        "External Test": "Externe test",
        "External Tester": "Extern testapparaat",
        "External URL": "Externe URL",
        "Facebook url": "Facebook-adres",
        "Failed Dependency": "Gefaalde afhankelijkheid",
        "Faq": "Faq",
        "Faqoverview": "Faqoverzicht",
        "File": "Bestand",
        "Fill in the 6-digit code": "Vul de 6-cijferige code in",
        "First name": "Voornaam",
        "First name *": "Voornaam *",
        "Fixed Cta": "Vaste Cta",
        "Follow up to": "Vervolg op",
        "Follow up tot": "Opvolging tot",
        "Font": "Lettertype",
        "Font size": "Lettertype grootte",
        "Font weight": "Lettertype style",
        "Footer background color": "Achtergrondkleur voettekst",
        "Footer bottom right": "Voettekst rechtsonder",
        "Footer color": "Kleur voettekst",
        "Footer contact title": "Titel contactpersoon voettekst",
        "Footer opening hours title (the middle one)": "Titel openingstijden voettekst (de middelste)",
        "Footer socials text": "Footer socials tekst",
        "Footer socials title": "Titel socials in voettekst",
        "Footer socials title (the last one)": "Footer socials titel (de laatste)",
        "Footer text color": "Tekstkleur voettekst",
        "Forbidden": "Verboden toegang",
        "Form Submission": "Formulier inzendingen",
        "Found": "Gevonden",
        "Frequently asked questions": "Veelgestelde vragen",
        "From the authenticator app": "Vanuit de authenticator app",
        "Fully rounded": "Volledig afgerond",
        "Gallery": "Galerie",
        "Gateway Timeout": "Gateway-time-out",
        "Global": "Algemeen",
        "Go to page {page}": "Ga naar pagina {page}",
        "Gone": "Verdwenen",
        "Google Authenticator": "Google Authenticator",
        "Google Maps": "Google-kaarten",
        "Google Maps Iframe": "Google Maps Iframe",
        "Google maps URL": "Google maps URL",
        "Google Maps URL": "Google Maps URL",
        "Header Opening hours": "Header Openingstijden",
        "Heading": "Rubriek",
        "Heading 1 is the main title and will be used on every page once": "Kop 1 is de hoofdtitel en wordt op elke pagina één keer gebruikt",
        "Heading 2 are the subtitles and can be used multiple times on a page": "Kop 2 zijn de ondertitels en kunnen meerdere keren op een pagina gebruikt worden",
        "Heading color": "Kleur kop",
        "Hello": "Hallo",
        "Hello!": "Hallo!",
        "Here you can turn on extra modules that are not included in the standard basic MediaMix template. Those are paid modules.": "Hier kun je extra modules inschakelen die niet in de standaard basis MediaMix-sjabloon zitten. Dit zijn betaalde modules.",
        "High": "Hoog",
        "High explanation": "Hoge uitleg",
        "Highest": "Hoogste",
        "Hits": "Hits",
        "Home Banner Slider Variant": "Home Banner schuifregelaar variant",
        "hour": "uur",
        "Hours": "Uren",
        "HTTP Version Not Supported": "HTTP-versie wordt niet ondersteund",
        "https://nl.linkedin.com/company/strixi": "https://nl.linkedin.com/company/strixi",
        "https://www.facebook.com/strixi.nl/": "https://www.facebook.com/strixi.nl/",
        "https://www.instagram.com/strixi.nl/": "https://www.instagram.com/strixi.nl/",
        "I agree with the": "Ik ga akkoord met de",
        "I agree with the terms and conditions*": "Ik ga akkoord met de algemene voorwaarden",
        "I have saved the backup codes": "Ik heb de back-up codes opgeslagen",
        "I'm a teapot": "Ik ben een theepot",
        "Icon": "Pictogram",
        "If enabled, and no image is uploaded, the banner from the homepage will be shown.": "Indien ingeschakeld, en er is geen afbeelding geupload, dan wordt de banner van de homepage getoond.",
        "If you did not create an account, no further action is required.": "Als je geen account hebt aangemaakt hoef je verder niets te doen.",
        "If you did not request a password reset, no further action is required.": "Als je geen wachtwoordherstel hebt aangevraagd, hoef je verder niets te doen.",
        "If you're having trouble clicking the \"{actionText}\" button, copy and paste the URL belowninto your web browser:": "Als je problemen hebt met de \"{actionText}\" knop, kopieer en plak de URL hierondernin je webbrowser:",
        "IM Used": "Ik ben gebruikt",
        "Image": "Afbeelding",
        "Including VAT": "Inclusief BTW",
        "Index Page": "Indexpagina",
        "Ingredients": "Ingrediënten",
        "Inloggen": "Inloggen",
        "Inspection": "Inspectie",
        "Instagram url": "Instagram-adres",
        "Instruction title": "Titel van de instructie",
        "Insufficient Storage": "Onvoldoende opslag",
        "Internal comment": "Interne opmerking",
        "Internal comments": "Interne opmerkingen",
        "Internal Server Error": "Interne serverfout",
        "Introduction": "Inleiding",
        "Invalid phone number": "Ongeldig telefoonnummer",
        "Invalid SSL Certificate": "Ongeldig SSL-certificaat",
        "It is recommended to keep the {attribute} between {min} and {max} characters long": "Het wordt aanbevolen het {attribute} tussen {min} en {max} tekens lang te houden.",
        "Job position": "Functie",
        "Kind regards,": "Met vriendelijke groet,",
        "Label Button": "Labelknop",
        "Language": "Taal",
        "Last message on": "Laatste bericht op",
        "Last name": "Achternaam",
        "Last name *": "Achternaam *",
        "Last refresh was {quantity} {unit} ago": "Laaste verversing was {quantity} {unit} geleden",
        "Leave empty for no end date": "Leeg laten voor geen einddatum",
        "Leave empty to use parent details": "Leeg laten om hoofdgegevens te gebruiken",
        "Length Required": "Lengte vereist",
        "Light": "Licht",
        "Line height": "Lijnhoogte",
        "Link Button": "Koppelingsknop",
        "LinkedIn url": "LinkedIn-adres",
        "Locale": "Taal",
        "Locked": "Afgesloten",
        "Login": "Inloggen",
        "Logo height": "Hoogte logo",
        "Logo slider": "Logo schuifbalk",
        "Logoslider": "Logoschuif",
        "Logout": "Uitloggen",
        "Loop Detected": "Loop gedetecteerd",
        "Low": "Laag",
        "Low explanation": "Lage uitleg",
        "Lowest": "Laagste",
        "Made by:": "Gerealiseerd door:",
        "Maintenance Mode": "Dienst niet beschikbaar",
        "Mark as done": "Markeren als gedaan",
        "Medical": "Medisch",
        "Medium": "Medium",
        "Menu Card": "Menukaart",
        "Menu Card Item": "Menukaart-item",
        "Menu items": "Menu-items",
        "Menu Title": "Menu Titel",
        "Menucard": "Menucard",
        "Message": "Bericht",
        "Message *": "Bericht",
        "Messages": "Berichten",
        "Method Not Allowed": "Methode niet toegestaan",
        "Metric Name": "Meetwaarden naam",
        "Microsoft Authenticator": "Microsoft Authenticator",
        "minus icon": "minpictogram",
        "minute": "minuut",
        "minutes": "minuten",
        "Misdirected Request": "Verkeerd geadresseerd verzoek",
        "Mobile": "Mobiel",
        "Modules": "Modules",
        "More information": "Meer informatie",
        "More settings can be set in the Page Block Settings page": "Meer instellingen kunnen worden ingesteld op de pagina Instellingen Paginablokkering",
        "Moved Permanently": "Definitief verplaatst",
        "Multi-Status": "Meerdere statussen",
        "Multiple Choices": "Meerkeuze",
        "MUST START with 31, folliwing with number WITHOUT 0. Otherwise it won't work!": "MOET beginnen met 31, gevolgd door een getal ZONDER 0. Anders werkt het niet!",
        "Mute client": "Mute client",
        "muted": "gedempt",
        "Muted": "Gedempt",
        "name": "naam",
        "Name": "Naam",
        "Name *": "Naam *",
        "Name client": "Naam cliënt",
        "Network Authentication Required": "Netwerkauthenticatie vereist",
        "Network Connect Timeout Error": "Fout bij time-out netwerkverbinding",
        "Network Read Timeout Error": "Time-outfout netwerk lezen",
        "New URL": "Nieuwe URL",
        "News": "Nieuws",
        "News Content": "Nieuws",
        "Newsletter": "Nieuwsbrief",
        "No": "Geen",
        "No Content": "Geen inhoud",
        "No items": "Geen items",
        "Non-Authoritative Information": "Niet-gemachtigde informatie",
        "None": "Geen",
        "Normal": "Normaal",
        "Not Acceptable": "Niet aanvaardbaar",
        "Not Extended": "Niet verlengd",
        "Not Found": "Niet gevonden",
        "Not Implemented": "Niet geïmplementeerd",
        "Not implemented yet": "Nog niet geïmplementeerd",
        "Not Modified": "Niet gewijzigd",
        "of": "van",
        "OK": "Oké",
        "Old URL": "Oude URL",
        "On your phone or tablet with camera. We can advise you to use {google} or {microsoft}.": "Op uw telefoon of tablet met camera. Wij kunnen u adviseren om {google} of {microsoft} te gebruiken.",
        "Open the authenticator app, add a new entry and scan the QR code": "Open de authenticator-app, voeg een nieuw item toe en scan de QR-code",
        "Opening hours": "Openingstijden",
        "Openings hours": "Openingstijden",
        "Order": "Bestel",
        "Origin Is Unreachable": "Herkomst is onbereikbaar",
        "Overview": "Overzicht",
        "Overwrite title color": "Titelkleur overschrijven",
        "Package name": "Pakket naam",
        "Packages": "Pakketten",
        "Page (within website)": "Pagina (binnen website)",
        "Page blocks": "Pagina blokken",
        "Page Expired": "Pagina niet meer geldig",
        "Page Header": "Pagina Header",
        "Page Title": "Pagina Titel",
        "PageHeader": "PageHeader",
        "Pagination Navigation": "Paginanavigatie",
        "Paragraph": "Paragraaf",
        "Parent category": "Hoofdcategorie",
        "Partial Content": "Gedeeltelijke inhoud",
        "Password": "Wachtwoord",
        "Paste in here only the Youtube ID. That id the ID what you see in the url in the browser after https://www.youtube.com/watch?v=": "Plak hier alleen de Youtube ID in. Dat id het ID wat je ziet in de url in de browser na https://www.youtube.com/watch?v=",
        "Paste or type the code we sent a code to your e-mail.": "Plak of typ de code die we naar je e-mail hebben gestuurd.",
        "Paste or type the code we sent a code to your phone number.": "Plak of typ de code die we naar je telefoonnummer hebben gestuurd.",
        "Payload Too Large": "Aanvraag te groot",
        "Payment Required": "Betaalde toegang",
        "PDF Menu cards": "PDF Menukaarten",
        "Permanent": "Permanent",
        "Permanent Redirect": "Definitieve omleiding",
        "Phone": "Telefoon",
        "Phone *": "Telefoonnummer *",
        "phone number": "telefoonnummer",
        "Phone number": "Telefoonnummer",
        "phone_number": "telefoonnummer",
        "Place": "Woonplaats",
        "Please click the button below to verify your email address.": "Klik op de knop hieronder om je e-mailadres te verifiëren.",
        "plus icon": "plus icoon",
        "Postal code": "Postcode",
        "Postcode": "Postcode",
        "Precondition Failed": "Niet voldaan aan de vooraf gestelde voorwaarde",
        "Precondition Required": "Voorwaarde nodig",
        "Price": "Prijs",
        "Price frequency": "Prijsfrequentie",
        "Primary": "Primair",
        "Primary Color": "Primaire kleur",
        "Primary Color (on dark backgrounds)": "Primaire kleur (op donkere achtergronden)",
        "Primary Hover Color": "Primaire hoverkleur",
        "Primary Hover Color (on dark backgrounds)": "Primaire hoverkleur (op donkere achtergronden)",
        "Primary text color": "Primaire tekstkleur",
        "Primary text color (on dark backgrounds)": "Primaire tekstkleur (op donkere achtergronden)",
        "Print": "Afdrukken",
        "Priority": "Prioriteit",
        "Privacy declaration": "Privacyverklaring",
        "privacy statement": "privacyverklaring",
        "Processing": "Verwerken",
        "Product": "Product",
        "Products": "Producten",
        "Project Content": "Inhoud project",
        "Projects": "Projecten",
        "Proxy Authentication Required": "Authenticatie op de proxyserver verplicht",
        "Question": "Vraag",
        "Railgun Error": "Railgun foutmelding",
        "Range Not Satisfiable": "Bereik niet bevredigend",
        "Reactivate": "Reactiveren",
        "Read more": "Lees meer",
        "Regards": "Met vriendelijke groet",
        "Register": "Registreren",
        "Regular": "Normaal",
        "Related products": "Verwante producten",
        "Remove": "Verwijder",
        "Remove discount code": "Kortingscode verwijderen",
        "Reopened subtask": "Heropende subtaak",
        "Request Header Fields Too Large": "Headers van de aanvraag te lang",
        "Request Timeout": "Aanvraagtijd verstreken",
        "Resend {attribute}": "Verstuur {attribute} opnieuw",
        "Reserved By": "Gereserveerd door",
        "Reset Content": "Inhoud opnieuw instellen",
        "Reset Password": "Wachtwoord herstellen",
        "Reset Password Notification": "Wachtwoordherstel notificatie",
        "results": "resultaten",
        "Results": "Resultaten",
        "Results are shared": "De resultaten worden gedeeld",
        "Retry With": "Opnieuw proberen met",
        "Review": "Review",
        "Review slider": "Beoordelingsschuif",
        "Review Slider": "Review Slider",
        "Reviews": "Beoordelingen",
        "Reviewslider": "Reviewslider",
        "role": "rol",
        "Role": "Rol",
        "Roles": "Rollen",
        "Rounded": "Afgerond",
        "Sampled at": "Afgenomen op",
        "Save": "Opslaan",
        "Save these codes on a secure place if you can’t get access with your Authenticator app.": "Bewaar deze codes op een veilige plek als je geen toegang krijgt met je Authenticator app.",
        "Scan the QR code": "Scan de QR-code",
        "Scanning not possible? Fill in this code in the app.": "Scannen niet mogelijk? Vul deze code in de app in.",
        "Search": "Zoek op",
        "Secondary": "Secundair",
        "Secondary Color": "Secundaire kleur",
        "See all faqs": "Bekijk alle vragen",
        "See Other": "Zie andere",
        "Select a {model}": "Selecteer een {model}",
        "Select a template to add the corresponding blocks.": "Selecteer een sjabloon om de bijbehorende blokken toe te voegen.",
        "Select a template to add the corresponding blocks. Note that this cannot be changed after page has been created": "Selecteer een template om de bijbehorende blokken toe te voegen. Let op: dit kan niet worden gewijzigd nadat de pagina is aangemaakt.",
        "Select a test": "Selecteer een test",
        "Select a type": "Selecteer een type",
        "Send application": "Verstuur sollicitatie",
        "SEO Description": "SEO Beschrijving",
        "SEO Settings for {lang}": "SEO instellingen voor {lang}",
        "SEO title": "SEO titel",
        "Server Error": "Server fout",
        "Service Unavailable": "Website onbeschikbaar",
        "Services": "Diensten",
        "Session Has Expired": "Pagina verlopen",
        "Set all titles to uppercase": "Maak alle titels hoofdletters",
        "Set color for the footer background": "Kleur instellen voor de achtergrond van de voettekst",
        "Set color for the footer text": "Kleur instellen voor de voettekst",
        "Set color for the footer.": "Kleur voor de voettekst instellen.",
        "Set Two Factor Authentication": "Twee Factor Authenticatie instellen",
        "Sets": "Zet",
        "Share results": "Resultaten delen",
        "shared": "gedeeld",
        "Shipping address same as billing address": "Verzendadres hetzelfde als factuuradres",
        "Shipping method": "Verzendmethode",
        "Shop": "Winkel",
        "Shop not finished yet...": "Winkel nog niet klaar...",
        "shopping cart": "winkelwagen",
        "Shopping cart": "Winkelwagen",
        "Show opening hours in header": "Toon openingstijden in koptekst",
        "Show phone number in header": "Toon telefoonnummer in koptekst",
        "Showing": "Toont",
        "Sign out": "Afmelden",
        "Slug": "Permalink",
        "Social media": "Sociale media",
        "SSL Handshake Failed": "SSL-handshake mislukt",
        "Stars": "Sterren",
        "Start": "Start",
        "Start date:": "Startdatum",
        "Started at": "Gestart op",
        "Status": "Status",
        "Statuses": "Statussen",
        "Street name": "Straatnaam",
        "Street number": "Huisnummer",
        "Street number addition": "Toevoeging",
        "Subject": "Onderwerp",
        "Subject *": "Onderwerp *",
        "Submit": "Verzenden",
        "SubTasks": "Subtaken",
        "Subtotal": "Subtotaal",
        "Switching Protocols": "Protocolwissel",
        "Task": "Taak",
        "Tasks": "Taken",
        "Team": "Team",
        "Temporary Redirect": "Tijdelijke omleiding",
        "terms and conditions": "algemene voorwaarden",
        "Terms and Conditions": "Algemene Voorwaarden",
        "Tertiary": "Tertiair",
        "Tertiary Color": "Tertiaire kleur",
        "test": "test",
        "Test": "Test",
        "test set": "testreeks",
        "Test set": "Testreeks",
        "Test sets": "Testreeksen",
        "Tests": "Tests",
        "Text": "Tekst",
        "Text transform": "Tekst transformeren",
        "Thank you for your application!": "Bedankt voor je sollicitatie!",
        "Thank you for your application. We will contact you shortly.": "Bedankt voor je sollicitatie. We nemen zo snel mogelijk contact met je op.",
        "Thank you for your message!": "Bedankt voor je bericht!",
        "Thank you for your sign up!": "Bedankt voor je aanmelding!",
        "The {attribute} has already been taken.": "Het {attribute} is al in gebruik.",
        "The {attribute} must be verified.": "Het {attribute} moet worden geverifieerd.",
        "The {attribute} must contain at least one letter.": "Het {attribute} moet minimaal één letter bevatten.",
        "The {attribute} must contain at least one number.": "Het {attribute} moet minimaal één cijfer bevatten.",
        "The {attribute} must contain at least one symbol.": "Het {attribute} moet minimaal één symbool bevatten.",
        "The {attribute} must contain at least one uppercase and one lowercase letter.": "Het {attribute} moet minimaal één hoofdletter en één kleine letter bevatten.",
        "The content of this block in the language you are editing is replaced. The other languages are left alone.": "De inhoud van dit blok in de taal die je bewerkt wordt vervangen. De andere talen blijven ongemoeid.",
        "The coupon has already been used.": "De coupon is al gebruikt.",
        "The coupon has expired.": "De coupon is verlopen.",
        "The font size for the main / body font.": "De lettergrootte voor het hoofdlettertype.",
        "The given {attribute} has appeared in a data leak. Please choose a different {attribute}.": "Het {attribute} is aangetroffen in een datalek. Geef een ander {attribute}.",
        "The given data was invalid.": "De gegeven data was ongeldig.",
        "The image of the language you are editing is replaced. The other languages are left alone.": "De afbeelding van de taal die je bewerkt wordt vervangen. De andere talen blijven ongemoeid.",
        "The provided {attribute} is invalid.": "Het opgegeven {attribute} is ongeldig.",
        "The provided code was invalid.": "De verstrekte code was ongeldig.",
        "The provided password does not match your current password.": "Het opgegeven wachtwoord komt niet overeen met uw huidige wachtwoord.",
        "The provided two factor authentication code was invalid.": "De verstrekte tweefactorauthenticatiecode was ongeldig.",
        "The styling for all mails like contactform, newsletter etc.": "De styling voor alle mails zoals contactformulier, nieuwsbrief enz.",
        "The tests cannot be changed once the test set is created.": "De tests kunnen niet worden gewijzigd nadat de testreeks is aangemaakt.",
        "The text color for primary elements, like buttons": "De tekstkleur voor primaire elementen, zoals knoppen",
        "The text color for primary elements, like buttons on a dark background": "De tekstkleur voor primaire elementen, zoals knoppen op een donkere achtergrond",
        "The thickness of the font that will be displayed": "De dikte van het lettertype dat wordt weergegeven",
        "The thickness of the font that will be displayed for all heading titles": "De dikte van het lettertype dat wordt weergegeven voor alle koptitels",
        "This {attribute} has already been used": "Dit {attribute} is al gebruikt",
        "This area is restricted to medical medic members only.": "Dit gebied is alleen toegankelijk voor medische leden.",
        "This area is restricted to staff members only.": "Dit gebied is alleen toegankelijk voor personeelsleden.",
        "This changes every language": "Dit verandert elke taal",
        "This font will be used as main / body font.": "Dit lettertype wordt gebruikt als hoofdlettertype.",
        "This font will be used for all heading titles H1, H2, H3. H4, H5, H6": "Dit lettertype wordt gebruikt voor alle koptitels H1, H2, H3. H4, H5, H6",
        "This is your first login": "Dit is uw eerste login",
        "This line must be as short as possible, otherwise the menu items won't fit at 1 line": "Deze regel moet zo kort mogelijk zijn, anders passen de menu-items niet op 1 regel",
        "This link expires in {number} hours": "Deze link verloopt over {number} uur",
        "This password reset link will expire in {count} minutes.": "Deze link om je wachtwoord te herstellen verloopt over {count} minuten.",
        "This task is reserved by {userName}": "Deze task is gereserveerd door {userName}",
        "This task is reserved by {userName}.": "Deze task is gereserveerd door {userName}.",
        "title": "titel",
        "Title": "Titel",
        "to": "tot",
        "To use Top Chefs Two Factor Authentication is required as extra security, you can set this now": "Om Topchefs te gebruiken is Two Factor Authentication nodig als extra beveiliging, u kunt dit nu instellen",
        "TODO": "TODO",
        "Toggle navigation": "Schakel navigatie",
        "token": "token",
        "Too Early": "Te vroeg",
        "Too Many Requests": "Te veel requests",
        "Total": "Totaal",
        "Trans": "Trans",
        "Two Factor Authentication - Backup codes": "Twee Factor Authenticatie - Back-up codes",
        "Type": "Type",
        "Type job position": "Type functie",
        "Unauthorized": "Niet geautoriseerd",
        "Unavailable For Legal Reasons": "Toegang geweigerd om juridische redenen",
        "Underline": "Onderstreept",
        "Unknown Error": "Onbekende foutmelding",
        "Unmute client": "Ontdemp client",
        "unmuted": "ontdempt",
        "Unprocessable Entity": "Aanvraag kan niet worden verwerkt",
        "Unsupported Media Type": "Media-type niet ondersteund",
        "Up": "Omhoog",
        "Update": "Bijwerken",
        "updated": "bijgewerkt",
        "Upgrade Required": "Upgrade nodig",
        "Upload C.V *": "Upload C.V *",
        "Upload cover letter *": "Upload motivatiebrief *",
        "Upload CV *": "Upload CV *",
        "Upload Motivation *": "Upload Motivatie *",
        "Uppercase": "Hoofdletters",
        "URI Too Long": "Aanvraag-URL te lang",
        "url": "url",
        "Url": "Url",
        "Use Proxy": "Gebruik Proxy",
        "user": "gebruiker",
        "User": "Gebruiker",
        "users": "gebruikers",
        "Users": "Gebruikers",
        "USPs": "USP's",
        "Uw winkelmand is leeg": "Uw winkelmand is leeg",
        "Vacancies": "Vacatures",
        "Vacancies Overview": "Overzicht vacatures",
        "Vacancy application form": "Vacature sollicitatieformulier",
        "Vacancy Content": "Vacature content",
        "Vacancy intro": "Vacature intro",
        "Vacancy recent": "Recente vacature",
        "Vacancyfilters": "Vacature filters",
        "Variant Also Negotiates": "Variant onderhandelt ook",
        "Variants": "Varianten",
        "VAT": "BTW",
        "Verify": "Controleer",
        "Verify {attribute}": "Verifieer {attribute}",
        "Verify Email Address": "Verifieer e-mailadres",
        "Videos": "Videos",
        "view": "bekijk",
        "View": "Bekijk",
        "view all": "bekijk alles",
        "View all": "Bekijk alles",
        "View project": "Bekijk project",
        "View vacancy": "Bekijk vacature",
        "We have done our best, but it seems that the page you requested does not exist (anymore) or that it may have moved.": "We hebben ons best gedaan, maar het lijkt erop dat de door u opgevraagde pagina niet (meer) bestaat of dat deze is verplaatst.",
        "We have received your message. One of our employees will contact you as soon as possible.": "We hebben uw bericht ontvangen. Een van onze medewerkers neemt zo snel mogelijk contact met u op.",
        "Web Page": "Website",
        "Web Page Settings": "Instellingen webpagina",
        "Web Server is Down": "Webserver is onbereikbaar",
        "weekly": "wekelijks",
        "Welcome": "Welkom",
        "Welcome to {page}": "Welkom op {page}",
        "WhatsApp Button": "WhatsApp-knop",
        "Whatsapp number": "Whatsapp nummer",
        "When enabled, an email will be sent to the user, letting them know their account has been created.": "Indien ingeschakeld, wordt een e-mail naar de gebruiker gestuurd om hem te laten weten dat zijn account is aangemaakt.",
        "Which blocks a page has is shared between languages, so adding or removing one here does the same in the other languages. Only the content inside a block belongs to the language you are editing.": "Welke blokken een pagina heeft is gedeeld tussen talen, dus een blok hier toevoegen of verwijderen doet hetzelfde in de andere talen. Alleen de inhoud ín een blok hoort bij de taal die je bewerkt.",
        "White": "Wit",
        "Whoops!": "Oeps!",
        "Will be used as color for the titles": "Wordt gebruikt als kleur voor de titels",
        "Will be used as hover main color for buttons, links, elements or components with a background color": "Wordt gebruikt als hover-hoofdkleur voor knoppen, links, elementen of onderdelen met een achtergrondkleur",
        "Will be used as hover main color on a dark background": "Wordt gebruikt als hover-hoofdkleur op een donkere achtergrond",
        "Will be used as main color for buttons, links, elements or components with a background color": "Wordt gebruikt als hoofdkleur voor knoppen, links, elementen of onderdelen met een achtergrondkleur",
        "Will be used as main color for the body text": "Wordt gebruikt als hoofdkleur voor de bodytekst",
        "Will be used as main color on a dark background": "Wordt gebruikt als hoofdkleur op een donkere achtergrond",
        "Yes": "Ja",
        "You are receiving this email because we received a password reset request for your account.": "Je ontvangt deze e-mail omdat we een wachtwoordherstel verzoek hebben ontvangen voor je account.",
        "You can contact us via the form. We look forward to hearing from you. Have you looked at the frequently asked questions? With the exception of weekends and holidays, we try to send you a response to your questions within 24 hours.": "U kunt contact met ons opnemen via het formulier. We horen graag van u. Heeft u gekeken naar de veelgestelde vragen? Met uitzondering van weekenden en feestdagen proberen we binnen 24 uur een reactie op uw vragen te sturen.",
        "You will receive this email because your account is ready for {siteName}": "Je ontvangt deze e-mail omdat je account klaar is voor {siteName}",
        "Your account for {siteName}": "Je account voor {siteName}",
        "Your account is inactive. Please contact support.": "Uw account is inactief. Neem contact op met support.",
        "Your account is inactive. Please contact support. To use the website as a guest, please refresh the page.": "Uw account is inactief. Neem contact op met support. Om de website als gast te gebruiken, vernieuwt u de pagina.",
        "Your current locale is {locale}": "Uw huidige locale is {locale}",
        "Your last login was {relativeTime} on {dateTime}": "Uw laatste login was {relativeTime} op {dateTime}",
        "Your order": "Uw bestelling",
        "Your Order": "Uw bestelling",
        "Your Profile": "Uw profiel",
        "Youtube": "Youtube",
        "Youtube Video ID": "Youtube-video-ID",
        "auth": {
            "failed": "Deze combinatie van e-mailadres en wachtwoord is niet geldig.",
            "password": "Wachtwoord is onjuist.",
            "throttle": "Te veel mislukte aanmeldpogingen. Probeer het nog eens over {seconds} seconden."
        },
        "validation": {
            "accepted": "{Attribute} moet worden geaccepteerd.",
            "accepted_if": "{Attribute} moet worden geaccepteerd als {other} {value} is.",
            "active_url": "{Attribute} is geen geldige URL.",
            "after": "{Attribute} moet een datum na {date} zijn.",
            "after_or_equal": "{Attribute} moet een datum na of gelijk aan {date} zijn.",
            "alpha": "{Attribute} mag alleen letters bevatten.",
            "alpha_dash": "{Attribute} mag alleen letters, nummers, underscores (_) en streepjes (-) bevatten.",
            "alpha_num": "{Attribute} mag alleen letters en nummers bevatten.",
            "array": "{Attribute} moet geselecteerde elementen bevatten.",
            "ascii": "De {attribute} mag alleen alfanumerieke tekens en symbolen van één byte bevatten.",
            "before": "{Attribute} moet een datum vóór {date} zijn.",
            "before_or_equal": "{Attribute} moet een datum vóór of gelijk aan {date} zijn.",
            "between": {
                "array": "{Attribute} moet tussen {min} en {max} waardes bevatten.",
                "file": "{Attribute} moet tussen {min} en {max} kilobytes zijn.",
                "numeric": "{Attribute} moet tussen {min} en {max} zijn.",
                "string": "{Attribute} moet tussen {min} en {max} karakters zijn."
            },
            "boolean": "{Attribute} moet ja of nee zijn.",
            "confirmed": "Bevestiging van {attribute} komt niet overeen.",
            "current_password": "Huidig wachtwoord is onjuist.",
            "date": "{Attribute} moet een datum bevatten.",
            "date_equals": "{Attribute} moet een datum gelijk aan {date} zijn.",
            "date_format": "{Attribute} voldoet niet aan het formaat {format}.",
            "decimal": "De {attribute} moet {decimal} decimalen hebben.",
            "declined": "{Attribute} moet afgewezen worden.",
            "declined_if": "{Attribute} moet afgewezen worden wanneer {other} gelijk is aan {value}.",
            "different": "{Attribute} en {other} moeten verschillend zijn.",
            "digits": "{Attribute} moet bestaan uit {digits} cijfers.",
            "digits_between": "{Attribute} moet bestaan uit minimaal {min} en maximaal {max} cijfers.",
            "dimensions": "{Attribute} heeft geen geldige afmetingen.",
            "distinct": "{Attribute} heeft een dubbele waarde.",
            "doesnt_end_with": "{Attribute} mag niet eindigen met één van de volgende waarden: {values}.",
            "doesnt_start_with": "{Attribute} mag niet beginnen met één van de volgende waarden: {values}.",
            "email": "{Attribute} is geen geldig e-mailadres.",
            "ends_with": "{Attribute} moet met één van de volgende waarden eindigen: {values}.",
            "enum": "Gekozen {attribute} is ongeldig.",
            "exists": "{Attribute} bestaat niet.",
            "file": "{Attribute} moet een bestand zijn.",
            "filled": "{Attribute} is verplicht.",
            "gt": {
                "array": "{Attribute} moet meer dan {value} waardes bevatten.",
                "file": "{Attribute} moet groter zijn dan {value} kilobytes.",
                "numeric": "{Attribute} moet groter zijn dan {value}.",
                "string": "{Attribute} moet meer dan {value} tekens bevatten."
            },
            "gte": {
                "array": "{Attribute} moet {value} of meer waardes bevatten.",
                "file": "{Attribute} moet groter of gelijk zijn aan {value} kilobytes.",
                "numeric": "{Attribute} moet groter of gelijk zijn aan {value}.",
                "string": "{Attribute} moet minimaal {value} tekens bevatten."
            },
            "image": "{Attribute} moet een afbeelding zijn.",
            "in": "{Attribute} is ongeldig.",
            "in_array": "{Attribute} bestaat niet in {other}.",
            "integer": "{Attribute} moet een getal zijn.",
            "ip": "{Attribute} moet een geldig IP-adres zijn.",
            "ipv4": "{Attribute} moet een geldig IPv4-adres zijn.",
            "ipv6": "{Attribute} moet een geldig IPv6-adres zijn.",
            "json": "{Attribute} moet een geldige JSON-string zijn.",
            "lowercase": "{Attribute} mag alleen kleine letters bevatten.",
            "lt": {
                "array": "{Attribute} moet minder dan {value} waardes bevatten.",
                "file": "{Attribute} moet kleiner zijn dan {value} kilobytes.",
                "numeric": "{Attribute} moet kleiner zijn dan {value}.",
                "string": "{Attribute} moet minder dan {value} tekens bevatten."
            },
            "lte": {
                "array": "{Attribute} moet {value} of minder waardes bevatten.",
                "file": "{Attribute} moet kleiner of gelijk zijn aan {value} kilobytes.",
                "numeric": "{Attribute} moet kleiner of gelijk zijn aan {value}.",
                "string": "{Attribute} moet maximaal {value} tekens bevatten."
            },
            "mac_address": "{Attribute} moet een geldig MAC-adres zijn.",
            "max": {
                "array": "{Attribute} mag niet meer dan {max} waardes bevatten.",
                "file": "{Attribute} mag niet meer dan {max} kilobytes zijn.",
                "numeric": "{Attribute} mag niet hoger dan {max} zijn.",
                "string": "{Attribute} mag niet uit meer dan {max} tekens bestaan."
            },
            "max_digits": "{Attribute} mag niet uit meer dan {max} cijfers bestaan.",
            "mimes": "{Attribute} moet een bestand zijn van het bestandstype {values}.",
            "mimetypes": "{Attribute} moet een bestand zijn van het bestandstype {values}.",
            "min": {
                "array": "{Attribute} moet minimaal {min} waardes bevatten.",
                "file": "{Attribute} moet minimaal {min} kilobytes zijn.",
                "numeric": "{Attribute} moet minimaal {min} zijn.",
                "string": "{Attribute} moet minimaal {min} tekens zijn."
            },
            "min_digits": "{Attribute} moet minimaal uit {min} cijfers bestaan.",
            "missing": "Het veld {attribute} moet ontbreken.",
            "missing_if": "Het veld {attribute} moet ontbreken als {other} {value} is.",
            "missing_unless": "Het veld {attribute} moet ontbreken, tenzij {other} {value} is.",
            "missing_with": "Het veld {attribute} moet ontbreken wanneer {values} aanwezig is.",
            "missing_with_all": "Het veld {attribute} moet ontbreken wanneer er {values} aanwezig zijn.",
            "multiple_of": "{Attribute} moet een veelvoud van {value} zijn.",
            "not_in": "{Attribute} is ongeldig.",
            "not_regex": "Het formaat van {attribute} is ongeldig.",
            "numeric": "{Attribute} moet een getal zijn.",
            "password": {
                "letters": "{Attribute} moet minimaal één letter bevatten.",
                "mixed": "{Attribute} moet minimaal één kleine letter en één hoofdletter bevatten.",
                "numbers": "{Attribute} moet minimaal één cijfer bevatten.",
                "symbols": "{Attribute} moet minimaal één vreemd teken bevatten.",
                "uncompromised": "Het opgegeven {attribute} komt voor in een datalek. Kies een ander {attribute}."
            },
            "present": "{Attribute} moet aanwezig zijn.",
            "prohibited": "{Attribute} is niet toegestaan.",
            "prohibited_if": "{Attribute} is niet toegestaan indien {other} gelijk is aan {value}.",
            "prohibited_unless": "{Attribute} is niet toegestaan tenzij {other} gelijk is aan {values}.",
            "prohibits": "{Attribute} is niet toegestaan in combinatie met {other}.",
            "regex": "Het formaat van {attribute} is ongeldig.",
            "required": "{Attribute} is verplicht.",
            "required_array_keys": "{Attribute} moet waardes bevatten voor {values}.",
            "required_if": "{Attribute} is verplicht indien {other} gelijk is aan {value}.",
            "required_if_accepted": "{Attribute} is verplicht indien {other} is geaccepteerd.",
            "required_unless": "{Attribute} is verplicht tenzij {other} gelijk is aan {values}.",
            "required_with": "{Attribute} is verplicht in combinatie met {values}.",
            "required_with_all": "{Attribute} is verplicht in combinatie met {values}.",
            "required_without": "{Attribute} is verplicht als {values} niet ingevuld is.",
            "required_without_all": "{Attribute} is verplicht als {values} niet ingevuld zijn.",
            "same": "{Attribute} en {other} moeten overeenkomen.",
            "size": {
                "array": "{Attribute} moet {size} waardes bevatten.",
                "file": "{Attribute} moet {size} kilobytes groot zijn.",
                "numeric": "{Attribute} moet {size} zijn.",
                "string": "{Attribute} moet {size} tekens zijn."
            },
            "starts_with": "{Attribute} moet beginnen met een van de volgende: {values}.",
            "string": "{Attribute} moet een tekst zijn.",
            "timezone": "{Attribute} moet een geldige tijdzone zijn.",
            "ulid": "De {attribute} moet een geldige ULID zijn.",
            "unique": "{Attribute} is al in gebruik.",
            "uploaded": "Het uploaden van {attribute} is mislukt.",
            "uppercase": "{Attribute} mag alleen hoofdletters bevatten.",
            "url": "{Attribute} moet een geldige URL zijn.",
            "uuid": "{Attribute} moet een geldige UUID zijn.",
            "attributes": {
                "address": "adres",
                "affiliate_url": "partner-URL",
                "age": "leeftijd",
                "amount": "bedrag",
                "announcement": "aankondiging",
                "area": "gebied",
                "audience_prize": "publieksprijs",
                "audience_winner": "audience winner",
                "available": "beschikbaar",
                "billing_address.city": "Plaats",
                "billing_address.company_name": "Bedrijfsnaam",
                "billing_address.country": "Land",
                "billing_address.postcode": "Postcode",
                "billing_address.street_name": "Straatnaam",
                "billing_address.street_number": "Huisnummer",
                "billing_address.street_number_addition": "Toevoeging",
                "billing_address.vat_number": "BTW nummer",
                "birthday": "verjaardag",
                "body": "inhoud",
                "city": "stad",
                "company": "company",
                "compilation": "compilatie",
                "concept": "concept",
                "conditions": "voorwaarden",
                "consultant_id": "Consultant",
                "content": "inhoud",
                "contest": "contest",
                "country": "land",
                "cover": "omslag",
                "created_at": "aangemaakt op",
                "creator": "maker",
                "currency": "valuta",
                "current_password": "huidig wachtwoord",
                "customer": "klant",
                "date": "datum",
                "date_of_birth": "geboortedatum",
                "dates": "datums",
                "day": "dag",
                "deleted_at": "verwijderd op",
                "description": "omschrijving",
                "display_type": "weergavetype",
                "district": "wijk",
                "duration": "tijdsduur",
                "email": "e-mailadres",
                "excerpt": "uittreksel",
                "filter": "filter",
                "finished_at": "klaar om",
                "first_name": "voornaam",
                "gender": "geslacht",
                "grand_prize": "grote prijs",
                "group": "groep",
                "hour": "uur",
                "image": "afbeelding",
                "image_desktop": "bureaubladafbeelding",
                "image_main": "hoofdafbeelding",
                "image_mobile": "mobiele afbeelding",
                "images": "afbeeldingen",
                "is_audience_winner": "is publiekswinnaar",
                "is_hidden": "is verborgen",
                "is_subscribed": "is geabonneerd",
                "is_visible": "is zichtbaar",
                "is_winner": "is winnaar",
                "items": "artikels",
                "key": "sleutel",
                "last_name": "achternaam",
                "lesson": "les",
                "line_address_1": "adresregel 1",
                "line_address_2": "adresregel 2",
                "login": "login",
                "message": "bericht",
                "middle_name": "tweede naam",
                "minute": "minuut",
                "mobile": "mobiel",
                "month": "maand",
                "name": "naam",
                "national_code": "landcode",
                "number": "nummer",
                "password": "wachtwoord",
                "password_confirmation": "wachtwoordbevestiging",
                "phone": "telefoonnummer",
                "photo": "foto",
                "portfolio": "portfolio",
                "postal_code": "postcode",
                "preview": "voorbeeld",
                "price": "prijs",
                "product_id": "product-ID",
                "product_uid": "product-UID",
                "product_uuid": "product-UUID",
                "promo_code": "promo-code",
                "province": "provincie",
                "quantity": "hoeveelheid",
                "reason": "reden",
                "recaptcha_response_field": "recaptcha-antwoordveld",
                "referee": "scheidsrechter",
                "referees": "scheidsrechters",
                "reject_reason": "afwijsreden",
                "remember": "onthouden",
                "restored_at": "hersteld op",
                "result_text_under_image": "antwoord tekst onder afbeelding",
                "role": "rol",
                "role_id": "rol",
                "rule": "regel",
                "rules": "regels",
                "second": "seconde",
                "sex": "geslacht",
                "shipment": "verzending",
                "shipping_address.city": "Plaats",
                "shipping_address.postcode": "Postcode",
                "shipping_address.street_name": "Straatnaam",
                "shipping_address.street_number": "Huisnummer",
                "shipping_address.street_number_addition": "Toevoeging",
                "shipping_rate_id": "Verzendmethode",
                "short_text": "korte tekst",
                "size": "grootte",
                "skills": "vaardigheden",
                "slug": "slug",
                "specialization": "specialisatie",
                "started_at": "gestart op",
                "state": "staat",
                "status": "status",
                "street": "straat",
                "student": "leerling",
                "subject": "onderwerp",
                "tag": "label",
                "tags": "labels",
                "teacher": "docent",
                "terms": "voorwaarden",
                "terms_and_conditions": "Algemene voorwaarden en privacy verklaring",
                "test_description": "testomschrijving",
                "test_locale": "testlandinstelling",
                "test_name": "testnaam",
                "text": "tekst",
                "time": "tijd",
                "title": "titel",
                "type": "type",
                "updated_at": "bijgewerkt op",
                "user": "gebruiker",
                "user_id": "gebruiker",
                "user_type": "gebruikerstype",
                "username": "gebruikersnaam",
                "value": "waarde",
                "winner": "winner",
                "work": "work",
                "year": "jaar",
                "cv": "cv",
                "locale": "taal",
                "motivation": "motivatie",
                "order": "bestelling",
                "place": "woonplaats",
                "url": "URL",
                "vacancy_id": "vacature"
            }
        },
        "http-statuses": {
            "0": "Onbekende foutmelding",
            "100": "Doorgaan",
            "101": "Protocolwissel",
            "102": "Verwerken",
            "200": "Oké",
            "201": "Aangemaakt",
            "202": "Aanvaard",
            "203": "Niet-gemachtigde informatie",
            "204": "Geen inhoud",
            "205": "Inhoud opnieuw instellen",
            "206": "Gedeeltelijke inhoud",
            "207": "Meerdere statussen",
            "208": "Al gemeld",
            "226": "Ik ben gebruikt",
            "300": "Meerkeuze",
            "301": "Definitief verplaatst",
            "302": "Gevonden",
            "303": "Zie andere",
            "304": "Niet gewijzigd",
            "305": "Gebruik Proxy",
            "307": "Tijdelijke omleiding",
            "308": "Definitieve omleiding",
            "400": "Foute aanvraag",
            "401": "Niet geautoriseerd",
            "402": "Betaalde toegang",
            "403": "Verboden toegang",
            "404": "Niet gevonden",
            "405": "Methode niet toegestaan",
            "406": "Niet aanvaardbaar",
            "407": "Authenticatie op de proxyserver verplicht",
            "408": "Aanvraagtijd verstreken",
            "409": "Conflict",
            "410": "Verdwenen",
            "411": "Lengte vereist",
            "412": "Niet voldaan aan de vooraf gestelde voorwaarde",
            "413": "Aanvraag te groot",
            "414": "Aanvraag-URL te lang",
            "415": "Media-type niet ondersteund",
            "416": "Bereik niet bevredigend",
            "417": "Niet voldaan aan verwachting",
            "418": "Ik ben een theepot",
            "419": "Pagina verlopen",
            "421": "Verkeerd geadresseerd verzoek",
            "422": "Aanvraag kan niet worden verwerkt",
            "423": "Afgesloten",
            "424": "Gefaalde afhankelijkheid",
            "425": "Te vroeg",
            "426": "Upgrade nodig",
            "428": "Voorwaarde nodig",
            "429": "Te veel requests",
            "431": "Headers van de aanvraag te lang",
            "444": "Verbinding gesloten zonder reactie",
            "449": "Opnieuw proberen met",
            "451": "Toegang geweigerd om juridische redenen",
            "499": "Klant Gesloten Verzoek",
            "500": "Interne serverfout",
            "501": "Niet geïmplementeerd",
            "502": "Slechte poort",
            "503": "Dienst niet beschikbaar",
            "504": "Gateway-time-out",
            "505": "HTTP-versie wordt niet ondersteund",
            "506": "Variant onderhandelt ook",
            "507": "Onvoldoende opslag",
            "508": "Loop gedetecteerd",
            "509": "Bandbreedte overschreden",
            "510": "Niet verlengd",
            "511": "Netwerkauthenticatie vereist",
            "520": "Onbekende foutmelding",
            "521": "Webserver is onbereikbaar",
            "522": "Connectie duurt te lang",
            "523": "Herkomst is onbereikbaar",
            "524": "Time-out opgetreden",
            "525": "SSL-handshake mislukt",
            "526": "Ongeldig SSL-certificaat",
            "527": "Railgun foutmelding",
            "598": "Time-outfout netwerk lezen",
            "599": "Fout bij time-out netwerkverbinding",
            "unknownError": "Onbekende foutmelding"
        },
        "routes": {
            "frequently-asked-questions": "veelgestelde-vragen",
            "blog": "blog",
            "projects": "projecten",
            "about-us": "over-ons",
            "general-terms": "algemene-voorwaarden",
            "products": "producten",
            "privacy-policy": "privacy-beleid",
            "cookie-policy": "cookie-beleid",
            "contact": "contact",
            "search": "zoeken",
            "vacancies": "vacatures",
            "faq": "faq",
            "team": "team",
            "news": "nieuws",
            "/projects": "projecten"
        },
        "passwords": {
            "reset": "Het wachtwoord van uw account is gewijzigd.",
            "sent": "We hebben een e-mail verstuurd met instructies om een nieuw wachtwoord in te stellen.",
            "throttled": "Gelieve even te wachten en het dan opnieuw te proberen.",
            "token": "Dit wachtwoordhersteltoken is niet geldig.",
            "user": "We hebben een e-mail verstuurd met instructies om een nieuw wachtwoord in te stellen."
        },
        "pagination": {
            "next": "Volgende &raquo;",
            "previous": "&laquo; Vorige"
        }
    }
}
